import globalConfig from '../../utiles/globalConfig';

const gameInfoConfig = {
  nowGameId: 191,
  // 全球末日
  191: {
    // 平台
    platform: 'global',
    // 游戏简码
    gameCode: 'ztmslg',
    // 页面title
    pageTitle: 'Puzzles & Survival Official Top-up Center',
    // 页面ico
    pageIco: require('@assets/image/officialStore/ztmslg/pns.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/ztmslg/icon191.png'); // 默认图标
      const gameId = globalConfig.getHrefParam('gameId'); // 链接游戏ID
      const iconMap = {
        191: defaultIcon,
        225: require('@assets/image/officialStore/ztmslg/icon225.png'), // 其他PNS游戏图标
        227: require('@assets/image/officialStore/ztmslg/icon227.png'), // 其他PNS游戏图标
        284: require('@assets/image/officialStore/ztmslg/icon284.png') // 其他PNS游戏图标
      };
      return iconMap[gameId] || defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    // 是否显示uid登录
    isUidLogin: true,
    // uid引导弹窗游戏图片1
    uidGuidePopupGameImg1: require('@assets/image/officialStore/ztmslg/uid-game-guide-1.png'),
    // uid引导弹窗游戏图片2
    uidGuidePopupGameImg2: require('@assets/image/officialStore/ztmslg/uid-game-guide-2.png'),
    // 是否显示账号登录
    isAccountLogin: true,
    // 是否显示uid令牌登录
    isUidTokenLogin: true,
    // uid令牌引导弹窗游戏图片
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/ztmslg/uid-token-game-guide.png'),
    // 是否显示VIP积分按钮
    isVipScore: true,
    // 是否显示我的优惠券入口
    isHeaderCoupon: true,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: true,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: true,
    // 是否显示钱包处的滚动广告条
    isShowAdvertiseBar: false,
    // 是否开启分享有利
    isShowShareBtn: true,
    // 是否显示自定义商品分类
    isCustomProductType: true,
    // 展示顶部安全检测
    isShowSafe: true,
    // 代币名称
    coinsName: 'Z-BIT',
    // 商品选择页显示代币提示语
    showCoinTips: true,
    // 展示非代币商品下架公告弹窗
    showProductOffTips: true,
    // 商品类型、ico、显示优先级
    productType: {
      typeall: {
        order: 1,
        img: require('@assets/image/officialStore/ztmslg/typeall.png')
      },
      ztmslgType1: {
        order: 2,
        img: require('@assets/image/officialStore/ztmslg/type1.png')
      },
      ztmslgType2: {
        order: 5,
        img: require('@assets/image/officialStore/ztmslg/type2.png')
      },
      ztmslgType3: {
        order: 9,
        img: require('@assets/image/officialStore/ztmslg/type3.png')
      },
      ztmslgType5: {
        order: 10,
        img: require('@assets/image/officialStore/ztmslg/type5.png')
      },
      ztmslgType6: {
        order: 11,
        img: require('@assets/image/officialStore/ztmslg/type6.png')
      },
      ztmslgType7: {
        order: 6,
        img: require('@assets/image/officialStore/ztmslg/type7.png')
      },
      ztmslgType8: {
        order: 7,
        img: require('@assets/image/officialStore/ztmslg/type8.png')
      },
      ztmslgType9: {
        order: 8,
        img: require('@assets/image/officialStore/ztmslg/type9.png')
      },
      ztmslgType10: {
        order: 12,
        img: require('@assets/image/officialStore/ztmslg/type10.png')
      },
      ztmslgType11: {
        order: 19,
        img: require('@assets/image/officialStore/ztmslg/type11.png')
      },
      ztmslgType12: {
        order: 13,
        img: require('@assets/image/officialStore/ztmslg/type12.png')
      },
      ztmslgType17: {
        order: 15,
        img: require('@assets/image/officialStore/ztmslg/type17.png')
      },
      ztmslgType13: {
        order: 14,
        img: require('@assets/image/officialStore/ztmslg/type13.png')
      },
      ztmslgType15: {
        order: 15,
        img: require('@assets/image/officialStore/ztmslg/type15.png')
      },
      ztmslgType16: {
        order: 16,
        img: require('@assets/image/officialStore/ztmslg/type16.png')
      },
      ztmslgType999: {
        order: 0,
        img: require('@assets/image/officialStore/ztmslg/type999.png')
      },
      ztmslgType9999: {
        order: 3,
        img: require('@assets/image/officialStore/ztmslg/type9999.png')
      },
      ztmslgType10000: {
        order: 4,
        img: require('@assets/image/officialStore/ztmslg/type10000.png')
      },
      ztmslgType10001: {
        order: 17,
        img: require('@assets/image/officialStore/ztmslg/type10001.png')
      },
      ztmslgTypeother: {
        order: 18,
        img: require('@assets/image/officialStore/ztmslg/typeother.png')
      }
    },
    // 道具详情是否读取开发商额外商品参数CP_PRODUCT_EXT
    isReadCpProductExt: true,
    // 道具详情是否读取后台配置的图标PRODUCT_ICON
    isReadProductIco: false,
    // 商品道具详情默认ico
    productPropDefaultIcoName: 'common-ico.png',
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Puzzles & Survival', //游戏名，用在规则里替换
      ruleNum: 13, // 规则数量
      table: [
        [
          '100',
          '7%OFF${couponCoupon}*1',
          '5%OFF${couponCoupon}*10\n${vipHeadAwardText}'
        ],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing',
      // 各币种优惠金额上限链接
      couponTopLimitLink: ''
    },
    // 登录模式，影响跳转登录按钮的文案；参数：guest(游客模式)|account (账密模式)
    loginType: 'guest',
    // 购物车是否显示不可使用双倍券提示
    isCartDoubleQuanTip: true,
    linkEntry: {
      // 跳转banner
      link: '', // 跳转地址
      img: {
        // 显示的图片
        default: '', //默认图片
        'zh-TW': require('@assets/image/officialStore/ztmslg/link-banner-tw.png'),
        'ja-JP': require('@assets/image/officialStore/ztmslg/link-banner-jp.png')
      }
    },
    // 代币多语言说明，每个游戏的说明不一样
    coinsIntro: {
      'ar-SA':
        'إن الـ[Z-BIT] هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام [Z-BIT] المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء [Z-BIT]عن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـPuzzle & Survival  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـ[Z-BIT] المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
      'de-DE':
        'Das [Z-BIT] ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten [Z-BIT]s zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst [Z-BIT]s mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Puzzle & Survival-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der [Z-BIT]s, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
      'en-US':
        'The [Z-BIT] is a feature that allows users to purchase goods and services using prepaid [Z-BIT]s. It is neither a bank account nor a method of payment. You may purchase [Z-BIT]s with a credit card, prepaid card, or any other payment method approved by the Puzzle & Survival Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of [Z-BIT]s you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
      'es-ES':
        'El [Z-BIT] es una función para que el usuario pueda comprar bienes y servicios utilizando los [Z-BIT]s prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar [Z-BIT]s con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Puzzle & Survival. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los [Z-BIT]s que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
      'fr-FR': `Le [Z-BIT] est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des [Z-BIT] prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des [Z-BIT] avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Puzzle & Survival. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des [Z-BIT]s que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
      'id-ID':
        'Puzzles&Survival bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. [Z-BIT] bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Puzzles&Survival  untuk menyetor modal Anda ke dalam [Z-BIT]. Jumlah maksimum ditentukan oleh  Puzzles&Survival  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di [Z-BIT] ditambah dengan total pengeluaran dari [Z-BIT] Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
      'it-IT': `[Z-BIT] è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando [Z-BIT] prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare [Z-BIT] con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Puzzle & Survival Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di [Z-BIT] che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
      'ja-JP':
        '『パズル&サバイバル』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『パズル&サバイバル』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
      'ko-KR':
        '퍼즐 오브 Z 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. [Z-BIT](은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 퍼즐 오브 Z 운영팀이 인정하는 기타 결제 방식으로 귀하의 [Z-BIT]에 금액을 예치해둘 수 있으며, 최대 예치 한도는 퍼즐 오브 Z 운영팀에서 결정합니다. 연속된 24시간 내에, [Z-BIT]에 예치 중인 총액과 [Z-BIT]로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
      'pl-PL':
        '[Z-BIT] to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić [Z-BIT] za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Puzzle & Survival. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
      'pt-PT':
        'O [Z-BIT] é um recurso que permite aos usuários adquirir bens e serviços usando [Z-BIT]s pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir [Z-BIT]s com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Puzzle & Survival. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de [Z-BIT]s que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
      'ru-RU':
        '[Z-BIT] — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные [Z-BIT]. Это не банковский счет и не способ оплаты. Вы можете приобрести [Z-BIT] с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Puzzle & Survival». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость [Z-BIT], которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
      'th-TH':
        'ทีมงาน Puzzles&Survival อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ [Z-BIT] ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Puzzles&Survival ยอมรับ เติมเงินเข้าสู่ [Z-BIT] ซึ่งยอดเงินสูงสุดจะมีทีมงาน Puzzles&Survival เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน [Z-BIT] ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก [Z-BIT] ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
      'tr-TR': `[Z-BIT], kullanıcıların ön ödemeli [Z-BIT]'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. [Z-BIT]'leri kredi kartı, ön ödemeli kart veya Puzzle & Survival Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın [Z-BIT]'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
      'vi-VN':
        'Nhóm vận hành Puzzles&Survival có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. 【Z-BIT】 không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Puzzles&Survival chấp nhận để gửi tiền vào 【Z-BIT】 của bạn, số dư tối đa do nhóm vận hành Puzzles&Survival xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong 【Z-BIT】 cộng với tổng số tiền thanh toán trong【Z-BIT】 không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
      'zh-CN':
        'Puzzles&Survival 运营团队可能会提供与您的帐户相关联的帐户余额。【Z-BIT】既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Puzzles&Survival 运营团队接受的任何其他付款方式将资金存入您的【Z-BIT】，最高金额由 Puzzles&Survival 运营团队确定。在任何二十四(24)小时内，存储在您的【Z-BIT】中的总金额加上从您的【Z-BIT】中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
      'zh-TW':
        'Puzzles&Survival 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。【Z-BIT】既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Puzzles&Survival 營運團隊接受的任何其他付款方式將資金存入您的【Z-BIT】，最高金額由 Puzzles&Survival 營運團隊確定。在任何二十四(24)小時內，儲存在您的【Z-BIT】中的總金額加上從您的【Z-BIT】中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: true,
    // FB分享的APPID
    shareFacebookAppId: 2303380839957579,
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'pnspwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心链接
    rightsCenterLink: `https://auto-page.${globalConfig.getMainHost()}/pnsvip01/`,
    // 权益中心上线时间
    onlineRightsCenterTime: '2025-07-16T00:00:00Z', // 权益中心上线时间，需加上时区信息
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 是否展示上线前弹窗
    isShowPreRightsPopup: true,
    offLineTime: '2025-07-16T00:00:00+00:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2025-07-16 00:00:00 (UTC)',
      'zh-CN': '2025-07-16 00:00:00 (UTC)',
      'vi-VN': '00:00:00 (UTC) ngày 16/07/2025',
      'tr-TR': '16/07/2025 00:00:00 (UTC)',
      'th-TH': '2025-07-16 เวลา 00:00:00 น.(UTC)',
      'ru-RU': '2025/07/16 00:00:00 (UTC)',
      'pt-PT': '16/07/2025 00:00:00 (UTC)',
      'pl-PL': '2025/07/16 00:00:00 (UTC)',
      'ko-KR': '2025-07-16 00:00:00(UTC)',
      'ja-JP': '2025 年 7 月 16 日 00:00:00(UTC)',
      'it-IT': '16/07/2025 00:00:00 (UTC)',
      'id-ID': '16/07/2025 00:00:00 (UTC)',
      'fr-FR': '16/07/2025 00:00:00 (UTC)',
      'es-ES': '16/07/2025 00:00:00 (UTC)',
      'en-US': '2025/07/16 00:00:00 (UTC)',
      'de-DE': '16.07.2025, 00:00:00 Uhr (UTC)',
      'ar-SA': '16-07-2025 00:00:00 (UTC)'
    },
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 全球蚂蚁
  263: {
    platform: 'global',
    gameCode: 'antslg',
    pageTitle: 'Ant Legion official top-up',
    pageIco: require('@assets/image/officialStore/antslg/ant.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/antslg/icon263.png'); // 默认图标
      return defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    isUidLogin: false,
    isAccountLogin: true,
    isUidTokenLogin: true,
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/antslg/uid-token-game-guide.png'),
    isVipScore: true,
    isHeaderCoupon: true,
    isCustomProductType: true,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: false,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: true,
    isShowAdvertiseBar: false,
    isShowShareBtn: false,
    // 展示顶部安全检测
    isShowSafe: true,
    productType: {
      typeall: {
        order: 0,
        img: require('@assets/image/officialStore/antslg/typeall.png')
      },
      antslgType999: {
        order: 1,
        img: require('@assets/image/officialStore/antslg/type999.png')
      },
      antslgType1: {
        order: 2,
        img: require('@assets/image/officialStore/antslg/type1.png')
      },
      antslgType2: {
        order: 4,
        img: require('@assets/image/officialStore/antslg/type2.png')
      },
      antslgType3: {
        order: 8,
        img: require('@assets/image/officialStore/antslg/type3.png')
      },
      antslgType5: {
        order: 9,
        img: require('@assets/image/officialStore/antslg/type5.png')
      },
      antslgType6: {
        order: 10,
        img: require('@assets/image/officialStore/antslg/type6.png')
      },
      antslgType7: {
        order: 5,
        img: require('@assets/image/officialStore/antslg/type7.png')
      },
      antslgType8: {
        order: 6,
        img: require('@assets/image/officialStore/antslg/type8.png')
      },
      antslgType9: {
        order: 7,
        img: require('@assets/image/officialStore/antslg/type9.png')
      },
      antslgType10: {
        order: 11,
        img: require('@assets/image/officialStore/antslg/type10.png')
      },
      antslgType11: {
        order: 19,
        img: require('@assets/image/officialStore/antslg/type11.png')
      },
      antslgType12: {
        order: 12,
        img: require('@assets/image/officialStore/antslg/type12.png')
      },
      antslgType13: {
        order: 13,
        img: require('@assets/image/officialStore/antslg/type13.png')
      },
      antslgType15: {
        order: 14,
        img: require('@assets/image/officialStore/antslg/type15.png')
      },
      antslgType9999: {
        order: 3,
        img: require('@assets/image/officialStore/antslg/type9999.png')
      },
      antslgTypeother: {
        order: 17,
        img: require('@assets/image/officialStore/antslg/typeother.png')
      }
    },
    isReadCpProductExt: true,
    isReadProductIco: false,
    productPropDefaultIcoName: 'common-ico.png',
    vipRuleConfig: {
      gameName: 'Ant Legion',
      ruleNum: 6, // 规则数量
      table: [
        ['50', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '500',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '2000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '5000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '10000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1YZ1XybJuJOLEYIIIx_mOnehr7GNKLcQHzpZYgtlQOZk/edit?usp=sharing'
    },
    loginType: 'guest',
    isCartDoubleQuanTip: true,
    linkEntry: {
      // 跳转banner
      link: '',
      img: {
        default: require('@assets/image/officialStore/antslg/link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/antslg/link-banner-en.png'),
        'zh-TW': require('@assets/image/officialStore/antslg/link-banner-tw.png'),
        'pt-PT': require('@assets/image/officialStore/antslg/link-banner-pt.png'),
        'ko-KR': require('@assets/image/officialStore/antslg/link-banner-kr.png'),
        'ja-JP': require('@assets/image/officialStore/antslg/link-banner-jp.png'),
        'fr-FR': require('@assets/image/officialStore/antslg/link-banner-fr.png'),
        'de-DE': require('@assets/image/officialStore/antslg/link-banner-de.png'),
        'ru-RU': require('@assets/image/officialStore/antslg/link-banner-ru.png')
      },
      leftLink: `//auto-page.${globalConfig.getMainHost()}/myvip01/`,
      rightLink: `//auto-page.${globalConfig.getMainHost()}/page-view/?aid=mayileichong1121&gameId=263`,
      leftImg: {
        default: require('@assets/image/officialStore/antslg/left-link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/antslg/left-link-banner-en.png')
      },
      rightImg: {
        default: require('@assets/image/officialStore/antslg/right-link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/antslg/right-link-banner-en.png')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: true,
    // FB分享的APPID
    shareFacebookAppId: 823239725291320,
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'antpwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 是否展示上线前弹窗
    isShowPreRightsPopup: false,
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心上线时间
    onlineRightsCenterTime: '2024-09-11T00:00:00+09:00', // 权益中心上线时间，需加上时区信息
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 权益中心链接
    rightsCenterLink: `https://auto-page.${globalConfig.getMainHost()}/myvip01/`,
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 全球大掌柜
  213: {
    platform: 'global',
    gameCode: 'dzg',
    pageTitle: 'TL Official Top-up',
    pageIco: require('@assets/image/officialStore/dzg/dzg.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/dzg/icon213.png'); // 默认图标
      return defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    isUidLogin: false,
    isAccountLogin: true,
    isUidTokenLogin: true,
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/dzg/uid-token-game-guide-global.png'),
    isVipScore: true,
    isHeaderCoupon: false,
    isCustomProductType: false,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: false,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    isShowAdvertiseBar: false,
    isShowShareBtn: false,
    // 展示顶部安全检测
    isShowSafe: true,
    productType: {
      typeall: {
        img: require('@assets/image/officialStore/dzg/typeall.png')
      },
      coin: {
        img: require('@assets/image/officialStore/dzg/coin.png')
      },
      package: {
        img: require('@assets/image/officialStore/dzg/package.png')
      },
      subscription: {
        img: require('@assets/image/officialStore/dzg/subscription.png')
      },
      currency: {
        img: require('@assets/image/officialStore/dzg/currency.png')
      }
    },
    isReadCpProductExt: false,
    isReadProductIco: true,
    productPropDefaultIcoName: 'daibi.png',
    vipRuleConfig: {
      gameName: 'Trading Legend-รวยรวยรวย',
      ruleNum: 6,
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    },
    loginType: 'account',
    isCartDoubleQuanTip: false,
    linkEntry: {
      // 跳转banner
      link: `https://auto-page.${globalConfig.getMainHost()}/dzgtl0117/?aid=dzgtl0117&gameId=213&cid=pay&scid=paybanner`, // 跳转地址
      img: {
        // 显示的图片
        default: require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'zh-TW': require('@assets/image/officialStore/dzg/link-banner-tw.png'),
        'pt-PT': require('@assets/image/officialStore/dzg/link-banner-pt.png'),
        'ko-KR': require('@assets/image/officialStore/dzg/link-banner-kr.png'),
        'ja-JP': require('@assets/image/officialStore/dzg/link-banner-jp.png'),
        'fr-FR': require('@assets/image/officialStore/dzg/link-banner-fr.png'),
        'de-DE': require('@assets/image/officialStore/dzg/link-banner-de.png'),
        'ar-SA': require('@assets/image/officialStore/dzg/link-banner-ar.png'),
        'ru-RU': require('@assets/image/officialStore/dzg/link-banner-ru.png'),
        'es-ES': require('@assets/image/officialStore/dzg/link-banner-es.png'),
        'it-IT': require('@assets/image/officialStore/dzg/link-banner-it.png'),
        'pl-PL': require('@assets/image/officialStore/dzg/link-banner-pl.png'),
        'id-ID': require('@assets/image/officialStore/dzg/link-banner-id.png'),
        'th-TH': require('@assets/image/officialStore/dzg/link-banner-th.png'),
        'tr-TR': require('@assets/image/officialStore/dzg/link-banner-tr.png'),
        'vi-VN': require('@assets/image/officialStore/dzg/link-banner-vi.png'),
        'zh-CN': require('@assets/image/officialStore/dzg/link-banner-cn.png')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dzgglpwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '구매 성공. 게임 내 우편에서 확인해주세요.',
      'ja-JP': '購入成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 是否展示上线前弹窗
    isShowPreRightsPopup: false,
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心上线时间
    onlineRightsCenterTime: '2024-08-16T12:00:00+09:00', // 权益中心上线时间，需加上时区信息
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 权益中心链接
    rightsCenterLink: `https://auto-page.${globalConfig.getMainHost()}/qqdzgvip01/`,
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 日本大掌柜
  209: {
    platform: 'global',
    gameCode: 'dzg',
    pageTitle: 'VIP会員専用購入サイト',
    pageIco: require('@assets/image/officialStore/dzg/dzg_jp.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/dzg/icon209.png'); // 默认图标
      return defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    isUidLogin: false,
    isAccountLogin: true,
    isUidTokenLogin: true,
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/dzg/uid-token-game-guide-jp.png'),
    isVipScore: true,
    isHeaderCoupon: false,
    isCustomProductType: false,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: false,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    isShowAdvertiseBar: false,
    isShowShareBtn: false,
    // 展示顶部安全检测
    isShowSafe: true,
    productType: {
      typeall: {
        img: require('@assets/image/officialStore/dzg/typeall.png')
      },
      coin: {
        img: require('@assets/image/officialStore/dzg/coin.png')
      },
      package: {
        img: require('@assets/image/officialStore/dzg/package.png')
      },
      subscription: {
        img: require('@assets/image/officialStore/dzg/subscription.png')
      },
      currency: {
        img: require('@assets/image/officialStore/dzg/currency.png')
      }
    },
    isReadCpProductExt: false,
    isReadProductIco: true,
    productPropDefaultIcoName: 'daibi.png',
    vipRuleConfig: {
      gameName: '商人放浪記',
      ruleNum: 12,
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '11%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '13%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n11%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n13%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    },
    loginType: 'guest',
    isCartDoubleQuanTip: false,
    linkEntry: {
      // 跳转banner
      link: '', // 跳转地址
      leftLink: `https://auto-page.${globalConfig.getMainHost()}/dzgjp_ngfl_03/`,
      rightLink: `https://auto-page.${globalConfig.getMainHost()}/dzg_0714/`,
      img: {},
      leftImg: {
        default: require('@assets/image/officialStore/dzg/left-link-banner-fanli-jp.jpg')
      },
      rightImg: {
        default: require('@assets/image/officialStore/dzg/right-link-banner-jp.jpg')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dzgjppwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '구매 성공. 게임 내 우편에서 확인해주세요.',
      'ja-JP': '購入成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 是否展示上线前弹窗
    isShowPreRightsPopup: false,
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心上线时间
    onlineRightsCenterTime: '2024-08-08T00:00:00+09:00', // 权益中心上线时间，需加上时区信息
    // 上线前弹窗链接
    preRightsPopupLink: '',
    // 权益中心链接
    rightsCenterLink: `https://auto-page.${globalConfig.getMainHost()}/vip01/`,
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 韩国大掌柜
  211: {
    platform: 'global',
    gameCode: 'dzg',
    pageTitle: '블랑코존 스토어',
    pageIco: require('@assets/image/officialStore/dzg/dzg_kr.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/dzg/icon211.png'); // 默认图标
      return defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    isUidLogin: false,
    isAccountLogin: true,
    isUidTokenLogin: true,
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/dzg/uid-token-game-guide-kr.png'),
    isVipScore: true,
    isHeaderCoupon: false,
    isCustomProductType: false,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: false,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    isShowAdvertiseBar: false,
    isShowShareBtn: false,
    // 展示顶部安全检测
    isShowSafe: true,
    productType: {
      typeall: {
        img: require('@assets/image/officialStore/dzg/typeall.png')
      },
      coin: {
        img: require('@assets/image/officialStore/dzg/coin.png')
      },
      package: {
        img: require('@assets/image/officialStore/dzg/package.png')
      },
      subscription: {
        img: require('@assets/image/officialStore/dzg/subscription.png')
      },
      currency: {
        img: require('@assets/image/officialStore/dzg/currency.png')
      }
    },
    isReadCpProductExt: false,
    isReadProductIco: true,
    productPropDefaultIcoName: 'daibi.png',
    vipRuleConfig: {
      gameName: '갑부: 장사의 시대',
      ruleNum: 12,
      table: [
        ['100', '7%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '1000',
          '10%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '12%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n10%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '14%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n12%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '16%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n14%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit?usp=sharing'
    },
    loginType: 'account',
    isCartDoubleQuanTip: false,
    linkEntry: {
      // 跳转banner
      link: 'https://auto-page.blancozone.com/dzgsfhg1117/?aid=dzgsfhg1117&gameId=211&cid=pay&scid=paybanner', // 跳转地址
      img: {
        // 显示的图片
        default: require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'zh-TW': require('@assets/image/officialStore/dzg/link-banner-tw.png'),
        'pt-PT': require('@assets/image/officialStore/dzg/link-banner-pt.png'),
        'ko-KR': require('@assets/image/officialStore/dzg/link-banner-kr.png'),
        'ja-JP': require('@assets/image/officialStore/dzg/link-banner-jp.png'),
        'fr-FR': require('@assets/image/officialStore/dzg/link-banner-fr.png'),
        'de-DE': require('@assets/image/officialStore/dzg/link-banner-de.png'),
        'ar-SA': require('@assets/image/officialStore/dzg/link-banner-ar.png'),
        'ru-RU': require('@assets/image/officialStore/dzg/link-banner-ru.png'),
        'es-ES': require('@assets/image/officialStore/dzg/link-banner-es.png'),
        'it-IT': require('@assets/image/officialStore/dzg/link-banner-it.png'),
        'pl-PL': require('@assets/image/officialStore/dzg/link-banner-pl.png'),
        'id-ID': require('@assets/image/officialStore/dzg/link-banner-id.png'),
        'th-TH': require('@assets/image/officialStore/dzg/link-banner-th.png'),
        'tr-TR': require('@assets/image/officialStore/dzg/link-banner-tr.png'),
        'vi-VN': require('@assets/image/officialStore/dzg/link-banner-vi.png'),
        'zh-CN': require('@assets/image/officialStore/dzg/link-banner-cn.png')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dzgkrpwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '구매 성공. 게임 내 우편에서 확인해주세요.',
      'ja-JP': '購入成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 是否展示上线前弹窗
    isShowPreRightsPopup: true,
    offLineTime: '2024-12-02T23:59:59+09:00', // 公告下线时间后不再弹窗时间，需加上时区信息
    offLineDate: {
      'zh-TW': '2024-11-18 23:59:59 (UTC+9)',
      'zh-CN': '2024-11-18 23:59:59 (UTC+9)',
      'vi-VN': '23:59:59 (UTC+9) ngày 18/11/2024',
      'tr-TR': '18/11/2024 23.59.59 (UTC+9)',
      'th-TH': '2024-11-18 เวลา 23:59:59 น.(UTC+9)',
      'ru-RU': '2024/11/18 23:59:59 (UTC+9)',
      'pt-PT': '18/11/2024 23:59:59 (UTC+9)',
      'pl-PL': '2024/11/18 23:59:59 (UTC+9)',
      'ko-KR': '2024-11-18 23:59:59(UTC+9)',
      'ja-JP': '2024 年 11 月 18 日 23:59:59(UTC+9)',
      'it-IT': '18/11/2024 23:59:59 (UTC+9)',
      'id-ID': '18/11/2024 23:59:59 (UTC+9)',
      'fr-FR': '18/11/2024 23:59:59 (UTC+9)',
      'es-ES': '18/11/2024 23:59:59 (UTC+9)',
      'en-US': '2024/11/18 23:59:59 (UTC+9)',
      'de-DE': '18.11.2024, 23:59:59 Uhr (UTC+9)',
      'ar-SA': '18-11-2024 23:59:59 (UTC+9)'
    },
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心上线时间
    onlineRightsCenterTime: '2024-11-19T00:00:00+09:00', // 权益中心上线时间，需加上时区信息
    // 权益中心链接
    rightsCenterLink: 'https://auto-page.blancozone.com/krdzgvip01/',
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 是否增送va优惠券活动
    vaCoupon: {
      isOpen: true,
      activitySign: 'dzgkrvacoupon'
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 越南大掌柜
  215: {
    platform: 'global',
    gameCode: 'dzg',
    pageTitle: 'Gọi Ta Đại Chưởng Quỹ',
    pageIco: require('@assets/image/officialStore/dzg/dzg_vi.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/dzg/icon215.png'); // 默认图标
      return defaultIcon; // safari添加到主屏幕图标,添加到主屏幕的图标只能是 PNG 格式，且必须是正方形，建议大小为 180x180
    })(),
    isUidLogin: false,
    isAccountLogin: true,
    isUidTokenLogin: true,
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/dzg/uid-token-game-guide-global-vi.png'),
    isVipScore: false,
    isHeaderCoupon: false,
    isCustomProductType: false,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: false,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    // 展示顶部安全检测
    isShowSafe: true,
    productType: {
      typeall: {
        img: require('@assets/image/officialStore/dzg/typeall.png')
      },
      coin: {
        img: require('@assets/image/officialStore/dzg/coin.png')
      },
      package: {
        img: require('@assets/image/officialStore/dzg/package.png')
      },
      subscription: {
        img: require('@assets/image/officialStore/dzg/subscription.png')
      },
      currency: {
        img: require('@assets/image/officialStore/dzg/currency.png')
      }
    },
    isReadCpProductExt: false,
    isReadProductIco: true,
    productPropDefaultIcoName: 'daibi.png',
    vipRuleConfig: {},
    loginType: 'account',
    isCartDoubleQuanTip: false,
    linkEntry: {
      // 跳转banner
      link: 'https://auto-page.olgamevn.com/dzgsanfangzhuhi1117/?aid=dzgsanfangzhuhi1117&gameId=215&cid=pay&scid=paybanner', // 跳转地址
      img: {
        // 显示的图片
        default: require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'en-US': require('@assets/image/officialStore/dzg/link-banner-en.png'),
        'zh-TW': require('@assets/image/officialStore/dzg/link-banner-tw.png'),
        'pt-PT': require('@assets/image/officialStore/dzg/link-banner-pt.png'),
        'ko-KR': require('@assets/image/officialStore/dzg/link-banner-kr.png'),
        'ja-JP': require('@assets/image/officialStore/dzg/link-banner-jp.png'),
        'fr-FR': require('@assets/image/officialStore/dzg/link-banner-fr.png'),
        'de-DE': require('@assets/image/officialStore/dzg/link-banner-de.png'),
        'ar-SA': require('@assets/image/officialStore/dzg/link-banner-ar.png'),
        'ru-RU': require('@assets/image/officialStore/dzg/link-banner-ru.png'),
        'es-ES': require('@assets/image/officialStore/dzg/link-banner-es.png'),
        'it-IT': require('@assets/image/officialStore/dzg/link-banner-it.png'),
        'pl-PL': require('@assets/image/officialStore/dzg/link-banner-pl.png'),
        'id-ID': require('@assets/image/officialStore/dzg/link-banner-id.png'),
        'th-TH': require('@assets/image/officialStore/dzg/link-banner-th.png'),
        'tr-TR': require('@assets/image/officialStore/dzg/link-banner-tr.png'),
        'vi-VN': require('@assets/image/officialStore/dzg/link-banner-vi.png'),
        'zh-CN': require('@assets/image/officialStore/dzg/link-banner-cn.png')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'dzgvnpwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {
      'en-US':
        'Purchase successful! Please keep an eye on your in-game mailbox.',
      'zh-CN': '儲值成功，請留意遊戲信件提示哦！',
      'zh-TW': '儲值成功，請留意遊戲信件提示哦！',
      'ko-KR': '구매 성공. 게임 내 우편에서 확인해주세요.',
      'ja-JP': '購入成功。ゲーム内の手紙にて確認してください！',
      'th-TH': 'เติมเงินสำเร็จ โปรดอย่าลืมเช็กอีเมลภายในเกมนะ!'
    },
    // 是否展示上线前弹窗
    isShowPreRightsPopup: false,
    // 是否上线权益中心
    isOnlineRightsCenter: false,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心链接
    rightsCenterLink: '',
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  },
  // 全球Puzzles & Chaos
  285: {
    platform: 'global',
    gameCode: 'dtmslg',
    pageTitle: 'PnC official top-up',
    pageIco: require('@assets/image/officialStore/dtmslg/dtmslg.png'),
    appleTouchIcon: (() => {
      const defaultIcon = require('@assets/image/officialStore/dtmslg/icon285.png');
      return defaultIcon;
    })(),
    // 是否显示uid登录
    isUidLogin: false,
    // 是否显示账号登录
    isAccountLogin: true,
    // 是否显示uid令牌登录
    isUidTokenLogin: false,
    // uid令牌引导弹窗游戏图片
    uidTokenGuidePopupGameImg: require('@assets/image/officialStore/dtmslg/uid-token-game-guide.png'),
    // 是否显示VIP积分按钮
    isVipScore: true,
    // 是否显示我的优惠券入口
    isHeaderCoupon: true,
    // 是否使用新版导航栏入口和代金币功能
    isUpdateNewVersion: true,
    // 是否显示钱包入口
    isShowWallet: false,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    // 是否显示钱包处的滚动广告条
    isShowAdvertiseBar: false,
    // 是否开启分享有礼
    isShowShareBtn: false,
    // 是否显示自定义商品分类
    isCustomProductType: true,
    // 代币名称
    coinsName: 'Diamonds',
    // 商品选择页显示代币提示语
    showCoinTips: true,
    // 展示非代币商品下架公告弹窗
    showProductOffTips: true,
    // 展示顶部安全检测
    isShowSafe: true,
    // 商品类型、ico、显示优先级
    productType: {
      typeall: {
        order: 1,
        img: require('@assets/image/officialStore/dtmslg/typeall.png')
      },
      dtmslgType10010: {
        order: 2,
        img: require('@assets/image/officialStore/dtmslg/type10010.png')
      },
      dtmslgType10020: {
        order: 3,
        img: require('@assets/image/officialStore/dtmslg/type10020.png')
      },
      dtmslgType10030: {
        order: 6,
        img: require('@assets/image/officialStore/dtmslg/type10030.png')
      },
      dtmslgType10040: {
        order: 14,
        img: require('@assets/image/officialStore/dtmslg/type10040.png')
      },
      dtmslgType10050: {
        order: 15,
        img: require('@assets/image/officialStore/dtmslg/type10050.png')
      },
      dtmslgType10060: {
        order: 17,
        img: require('@assets/image/officialStore/dtmslg/type10060.png')
      },
      dtmslgType10070: {
        order: 18,
        img: require('@assets/image/officialStore/dtmslg/type10070.png')
      },
      dtmslgType10080: {
        order: 16,
        img: require('@assets/image/officialStore/dtmslg/type10080.png')
      },
      dtmslgType10090: {
        order: 7,
        img: require('@assets/image/officialStore/dtmslg/type10090.png')
      },
      dtmslgType10100: {
        order: 8,
        img: require('@assets/image/officialStore/dtmslg/type10100.png')
      },
      dtmslgType10110: {
        order: 13,
        img: require('@assets/image/officialStore/dtmslg/type10110.png')
      },
      dtmslgType10120: {
        order: 19,
        img: require('@assets/image/officialStore/dtmslg/type10120.png')
      },
      dtmslgType10130: {
        order: 21,
        img: require('@assets/image/officialStore/dtmslg/type10130.png')
      },
      dtmslgType10140: {
        order: 0,
        img: require('@assets/image/officialStore/dtmslg/type10140.png')
      },
      dtmslgType2: {
        order: 5,
        img: require('@assets/image/officialStore/dtmslg/type2.png')
      },
      dtmslgType3: {
        order: 4,
        img: require('@assets/image/officialStore/dtmslg/type3.png')
      },
      dtmslgType4: {
        order: 9,
        img: require('@assets/image/officialStore/dtmslg/type4.png')
      },
      dtmslgType5: {
        order: 10,
        img: require('@assets/image/officialStore/dtmslg/type5.png')
      },
      dtmslgType20010: {
        order: 11,
        img: require('@assets/image/officialStore/dtmslg/type20010.png')
      },
      dtmslgType20021: {
        order: 12,
        img: require('@assets/image/officialStore/dtmslg/type20021.png')
      },
      dtmslgTypeother: {
        order: 20,
        img: require('@assets/image/officialStore/dtmslg/typeother.png')
      }
    },
    // 道具详情是否读取开发商额外商品参数CP_PRODUCT_EXT
    isReadCpProductExt: true,
    // 道具详情是否读取后台配置的图标PRODUCT_ICON
    isReadProductIco: false,
    // 商品道具详情默认ico
    productPropDefaultIcoName: 'common-ico.png',
    // vip积分活动规则配置
    vipRuleConfig: {
      gameName: 'Puzzles & Chaos', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      table: [
        [
          '100',
          '7%OFF${couponCoupon}*1',
          '5%OFF${couponCoupon}*10\n${vipHeadAwardText285}'
        ],
        [
          '1000',
          '8%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*5'
        ],
        [
          '5000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n8%OFF${couponCoupon}*3'
        ],
        [
          '10000',
          '10%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*2'
        ],
        [
          '20000',
          '15%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n10%OFF${couponCoupon}*1'
        ]
      ],
      link: 'https://docs.google.com/spreadsheets/d/1dPZMdmkfg8QQXRAnHDkqlmzmcg1V_SYkIRBY9lxG4Pc/edit#gid=0',
      // 各币种优惠金额上限链接
      couponTopLimitLink: ''
    },
    // 登录模式，影响跳转登录按钮的文案；参数：guest(游客模式)|account (账密模式)
    loginType: 'guest',
    // 购物车是否显示不可使用双倍券提示
    isCartDoubleQuanTip: true,
    linkEntry: {
      // 跳转banner
      link: '', // 跳转地址
      img: {
        // 显示的图片
        default: '', //默认图片
        'en-US': '' //对应语言的图片
      }
    },
    // 代币多语言说明，每个游戏的说明不一样
    coinsIntro: {
      'ar-SA':
        'إن الـZ-BIT هو خاصية تتيح للمستخدمين شراء السلع والخدمات باستخدام Z-BIT المدفوع مقدمًا. هذا ليس حسابًا بنكيًا ولا وسيلة دفع. حيث يمكنك شراء Z-BITعن طريق بطاقات المشتريات أو بطاقات الخصم المباشر أو أي وسيلة دفع مقبولة من طرففريق العملياتالخاص بـPuzzles & Chaos  .أقصى مبلغ مسموح به في المعاملة الواحدة يُحدد من قِبَل الفريق. يرجى العلم أن القيمة الإجمالية لـZ-BIT المسموح بشرائها وإنفاقها خلال 24 ساعة لا يمكن أن تتخطى $5,000 أو ما يقابلها بعملتك المحلية.',
      'de-DE':
        'Das Z-BIT ist eine Funktion, die es Benutzern ermöglicht, Waren und Dienstleistungen mit vorausbezahlten Z-BITs zu kaufen. Es ist weder ein Bankkonto noch eine Zahlungsmethode. Du kannst Z-BITs mit einer Kreditkarte, Prepaid-Karte oder einer anderen vom Puzzles & Chaos-Team genehmigten Zahlungsmethode kaufen. Der maximale Kaufbetrag pro Transaktion wird vom Team festgelegt. Bitte beachte, dass der Gesamtwert der Z-BITs, die du kaufst und innerhalb von 24 Stunden ausgibst, $5.000 oder den entsprechenden Betrag in deiner Landeswährung nicht überschreiten darf.',
      'en-US':
        'The Z-BIT is a feature that allows users to purchase goods and services using prepaid Z-BITs. It is neither a bank account nor a method of payment. You may purchase Z-BITs with a credit card, prepaid card, or any other payment method approved by the Puzzles & Chaos Operations Team. The maximum purchase amount per transaction is determined by the team. Please note that the total value of Z-BITs you purchase and spend within 24 hours cannot exceed $5,000 or the equivalent amount in your local currency.',
      'es-ES':
        'El Z-BIT es una función para que el usuario pueda comprar bienes y servicios utilizando los Z-BITs prepagos. No es una cuenta bancaria ni un método de pago. Puedes comprar Z-BITs con una tarjeta de crédito, una tarjeta prepaga o cualquier otro método de pago aprobado por el equipo de operaciones de Puzzles & Chaos. El importe máximo de compra por transacción lo determina el equipo. Ten en cuenta que el valor total de los Z-BITs que compres y gastes en 24 horas no puede superar los 5000 dólares o la cantidad equivalente de tu moneda local.',
      'fr-FR': `Le Z-BIT est une fonctionnalité qui permet aux utilisateurs d'acheter des biens et des services en utilisant des Z-BIT prépayés. Il ne s'agit ni d'un compte bancaire ni d'un mode de paiement. Vous pouvez acheter des Z-BIT avec une carte de crédit, une carte prépayée ou tout autre moyen de paiement approuvé par l'équipe des opérations de Puzzles & Chaos. Le montant maximum d'achat par transaction est déterminé par l'équipe. Veuillez noter que la valeur totale des Z-BITs que vous achetez et dépensez dans les 24 heures ne peut dépasser 5 000 $ ou le montant équivalent dans votre devise locale.`,
      'id-ID':
        'Puzzles & Chaos bagian tim operasional mungkin akan menyediakan akun saldo yang terkait dengan akun Anda. Z-BIT bukan rekening bank, juga bukan alat pembayaran apa pun. Ia sebagai saldo prabayar konten pesanan dan layanan. Melalui kartu kredit, kartu prabayar atau cara pembayaran lain yang disetujui oleh tim operasional Puzzles & Chaos  untuk menyetor modal Anda ke dalam Z-BIT. Jumlah maksimum ditentukan oleh  Puzzles & Chaos  bagian tim operasional. Dalam 24 jam, total nilai yang Anda simpan di Z-BIT ditambah dengan total pengeluaran dari Z-BIT Anda tidak boleh melebihi $5,000 atau senilai mata uang lokal yang Anda gunakan.',
      'it-IT': `Z-BIT è una funzionalità che consente agli utenti di acquistare beni e servizi utilizzando Z-BIT prepagati.  Non è né un conto bancario né un metodo di pagamento.  È possibile acquistare Z-BIT con carta di credito, carta prepagata o qualsiasi altro metodo di pagamento approvato dal Puzzles & Chaos Operations Team.  L'importo massimo di acquisto per transazione è determinato dal team.  Tieni presente che il valore totale di Z-BIT che acquisti e spendi entro 24 ore non può superare $ 5.000 o l'importo equivalente nella tua valuta locale.`,
      'ja-JP':
        '『Puzzles & Chaos』運営チームが新たにZ-BIT機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。Z-BITとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『Puzzles & Chaos』運営チームが承認するその他決済方法でZ-BITを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
      'ko-KR':
        'Puzzles & Chaos 운영팀에서는 귀하의 계정과 관련된 계정 잔액을 제공할 수도 있습니다. Z-BIT(은)는 은행 계좌 또는 결제 도구가 아니며, 콘텐츠 및 서비스 주문과 관련된 예치금 잔액으로만 사용됩니다. 신용카드, 선불 카드 또는 Puzzles & Chaos 운영팀이 인정하는 기타 결제 방식으로 귀하의 Z-BIT에 금액을 예치해둘 수 있으며, 최대 예치 한도는 Puzzles & Chaos 운영팀에서 결정합니다. 연속된 24시간 내에, Z-BIT에 예치 중인 총액과 Z-BIT로 지불된 총액의 합은 미화 5,000$ 또는 이에 상당하는 현지 통화 금액을 초과할 수 없습니다.',
      'pl-PL':
        'Z-BIT to funkcja, która umożliwia użytkownikom zakup towarów i usług przy użyciu przedpłaconych [Z-BITów]. Nie jest to ani konto bankowe, ani metoda płatności. Użytkownik może zakupić Z-BIT za pomocą karty kredytowej, karty przedpłaconej lub innej metody płatności zatwierdzonej przez zespół operacyjny Puzzles & Chaos. Maksymalna kwota zakupu dla jednej transakcji jest określana przez zespół. Należy pamiętać, że łączna wartość [Z-BITów] zakupionych i wydanych w ciągu 24 godzin nie może przekroczyć 5 000 USD lub równowartości tej kwoty w lokalnej walucie.',
      'pt-PT':
        'O Z-BIT é um recurso que permite aos usuários adquirir bens e serviços usando Z-BITs pré-pagos. Não é uma conta bancária nem um método de pagamento. Você pode adquirir Z-BITs com um cartão de crédito, cartão pré-pago, ou qualquer outro método de pagamento aprovado pela Equipe de Operações Puzzles & Chaos. O valor máximo de compra por transação é determinado pela equipe. Observe que o valor total de Z-BITs que você compra e gasta em 24 horas não pode exceder $5.000 dólares ou o valor equivalente em sua moeda local.',
      'ru-RU':
        'Z-BIT — это функция, которая позволяет пользователям приобретать предметы и услуги за предоплаченные Z-BIT. Это не банковский счет и не способ оплаты. Вы можете приобрести Z-BIT с помощью кредитной карты, карты предоплаты или любого другого способа оплаты, одобренного командой «Puzzles & Chaos». Максимальная сумма покупки за транзакцию определяется нашей командой. Обратите внимание, что общая стоимость Z-BIT, которые вы покупаете и тратите в течение 24 часов, не может превышать 5000$ или эквивалентную сумму в вашей местной валюте.',
      'th-TH':
        'ทีมงาน Puzzles & Chaos อาจแจ้งยอดเงินภายในบัญชีที่เชื่อมโยงกับบัญชีของคุณ Z-BIT ไม่ใช่ทั้งบัญชีธนาคารและไม่ใช้เครื่องมือการชำระเงิน แต่เป็นยอดเงินพรีเพดที่ใช้ในการซื้อเนื้อหาและบริการต่างๆ คุณสามารถใช้บัตรเครดิต, บัตรพรีเพด หรือช่องทางการชำระเงินต่างๆ ที่ทีมงาน Puzzles & Chaos ยอมรับ เติมเงินเข้าสู่ Z-BIT ซึ่งยอดเงินสูงสุดจะมีทีมงาน Puzzles & Chaos เป็นผู้กำหนด ทั้งนี้ทั้งนั้น ยอดเงินรวมที่คุณฝากไว้ใน Z-BIT ของคุณ บวกกับ ยอดเงินรวมที่คุณใช้จาก Z-BIT ของคุณ ต้องรวมกันไม่เกิน 5,000 ดอลล่าสหรัฐฯ หรือ จำนวนเงินที่มีมูลค่าเท่ากันตามสกุลเงินท้องถิ่นที่คุณใช้',
      'tr-TR': `Z-BIT, kullanıcıların ön ödemeli Z-BIT'leri kullanarak mal ve hizmet satın almalarını sağlayan bir özelliktir. Ne bir banka hesabı ne de bir ödeme yöntemidir. Z-BIT'leri kredi kartı, ön ödemeli kart veya Puzzles & Chaos Operasyon Ekibi tarafından onaylanmış herhangi bir ödeme yöntemiyle satın alabilirsin. İşlem başına maksimum satın alma tutarı ekip tarafından belirlenir. 24 saat içinde satın aldığın ve harcadığın Z-BIT'lerin toplam değeri, $5.000 veya yerel para birimindeki eşdeğer tutarı aşamaz.`,
      'vi-VN':
        'Nhóm vận hành Puzzles & Chaos có thể sẽ cung cấp số dư tài khoản liên quan tới tài khoản của bạn. Z-BIT không phải là tài khoản ngân hàng, cũng không phải bất kỳ công cụ thanh toán nào. Nó được sử dụng để thanh toán trước số dư nhằm đặt mua nội dung và dịch vụ trong game. Bạn có thể sử dụng thẻ tín dụng, thẻ trả trước hoặc bất kỳ phương thức thanh toán nào khác mà nhóm vận hành Puzzles & Chaos chấp nhận để gửi tiền vào Z-BIT của bạn, số dư tối đa do nhóm vận hành Puzzles & Chaos xác nhận. Trong 24 giờ bất kỳ, tổng số dư bạn để trong Z-BIT cộng với tổng số tiền thanh toán trongZ-BIT không được quá 5,000 USD hoặc giá trị tương đương với loại tiền tệ khu vực bạn sử dụng.',
      'zh-CN':
        'Puzzles & Chaos 运营团队可能会提供与您的帐户相关联的帐户余额。Z-BIT既不是银行账户，也不是任何类型的支付工具。它用作订购内容和服务的预付余额。您可以通过信用卡、预付卡或 Puzzles & Chaos 运营团队接受的任何其他付款方式将资金存入您的Z-BIT，最高金额由 Puzzles & Chaos 运营团队确定。在任何二十四(24)小时内，存储在您的Z-BIT中的总金额加上从您的Z-BIT中支出的总金额的总和不得超过 5,000美元 或以您适用的当地货币表示的等值金额。',
      'zh-TW':
        'Puzzles & Chaos 營運團隊可能會提供與您的帳戶相關聯的帳戶餘額。Z-BIT既不是銀行帳戶，也不是任何類型的支付工具。它用作訂購內容和服務的預付餘額。您可以通過信用卡、預付卡或 Puzzles & Chaos 營運團隊接受的任何其他付款方式將資金存入您的Z-BIT，最高金額由 Puzzles & Chaos 營運團隊確定。在任何二十四(24)小時內，儲存在您的Z-BIT中的總金額加上從您的Z-BIT中支出的總金額的總和不得超過 5,000美元 或以您適用的當地貨幣表示的等值金額。'
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: true,
      activityName: 'k1pwagift'
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 是否上线权益中心
    isOnlineRightsCenter: true,
    // 暂时展示VIP规则
    tempShowVipRuleByRightsOnEndDate: '2025-11-18T00:00:00+08:00',
    // 权益中心链接
    rightsCenterLink: `https://auto-page.${globalConfig.getMainHost()}/k1vip01/`,
    // 权益中心上线时间
    onlineRightsCenterTime: '2025-11-03T00:00:00+08:00', // 权益中心上线时间，需加上时区信息
    // 限时活动
    limitedTimeActivity: {
      isOpen: (() => {
        if (new Date('2025-11-01T00:00:00Z') < new Date()) {
          return false;
        }
        return true;
      })(),
      activitySign: 'k1payevents1',
      ruleNum: 10, // 规则数量,语言*规则数量数量太多了，不额外配置，跟据gameId和数量自动获取
      awardList: {
        1: {
          limitedPay: false,
          limitedTime: '',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-1.png'),
              num: 5
            }
          ],
          awardDetail: {
            default: 'Small Speedup Chest*5',
            'ar-SA': '',
            'de-DE': 'Kleine Beschleunigungstruhe*5',
            'en-US': 'Small Speedup Chest*5',
            'es-ES': 'Cofre pequeño de Aceleradores*5',
            'fr-FR': 'Petit coffre d’accélération*5',
            'id-ID': 'Kotak Akselerasi (S)*5',
            'it-IT': 'Cassa Velocizz. Piccola*5',
            'ja-JP': '小型加速ボックス*5',
            'ko-KR': '소형 가속 보물상자*5',
            'pl-PL': '',
            'pt-PT': 'Baú Pequeno de Aceleração*5',
            'ru-RU': 'Малый Сундук с Ускорениями*5',
            'th-TH': 'หีบเร่งสปีดมินิ*5',
            'tr-TR': 'Küçük Hızlandırma Sandığı*5',
            'vi-VN': 'Rương Tăng Tốc Nhỏ*5',
            'zh-CN': '小型加速宝箱*5',
            'zh-TW': '小型加速寶箱*5'
          },
          taskName: {
            default: 'Weekly Log in Pack',
            'ar-SA': '',
            'de-DE': 'Wöchentl. Anmeldepaket',
            'en-US': 'Weekly Log in Pack',
            'es-ES': 'Paquete de inicio de sesión semanal',
            'fr-FR': 'Pack de connexion hebdomadaire',
            'id-ID': 'Paket Login Mingguan',
            'it-IT': 'Pacchetto Accesso Settim.',
            'ja-JP': '週間ログインギフト',
            'ko-KR': '매주 로그인 패키지',
            'pl-PL': '',
            'pt-PT': 'Pacote de Login Semanal',
            'ru-RU': 'Недельный набор за вход',
            'th-TH': 'แพ็กล็อกอินรายสัปดาห์',
            'tr-TR': 'Haftalık Giriş Paketi',
            'vi-VN': 'Gói Đăng Nhập Hàng Tuần',
            'zh-CN': '每周登录礼包',
            'zh-TW': '每週登錄禮包'
          }
        },
        2: {
          limitedPay: false,
          limitedTime: 'weekly',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-2.png'),
              num: 3
            }
          ],
          awardDetail: {
            default: 'Energy Crystal Choice Chest*3',
            'ar-SA': '',
            'de-DE': 'Energiekristall-Wahltruhe*3',
            'en-US': 'Energy Crystal Choice Chest*3',
            'es-ES': 'Cofre de elección de Cristales de Energía*3',
            'fr-FR': 'Coffre de choix de cristal d’énergie*3',
            'id-ID': 'Kotak Opsi Kristal Energi*3',
            'it-IT': 'Cassa Scelta Cristallo Energia*3',
            'ja-JP': 'エネルギークリスタル選択補給箱*3',
            'ko-KR': '에너지 결정체 선택상자*3',
            'pl-PL': '',
            'pt-PT': 'Baú de Escolha de Cristal Energético*3',
            'ru-RU': 'Сундук с Энергетическими Кристаллами на Выбор*3',
            'th-TH': 'หีบเลือกผลึกพลังงาน*3',
            'tr-TR': 'Enerji Kristali Seçim Sandığı*3',
            'vi-VN': 'Rương Tiếp Tế Tinh Thể Năng Lượng (Chọn)*3',
            'zh-CN': '能量晶体选择补给箱*3',
            'zh-TW': '能量晶體選擇補給箱*3'
          },
          taskName: {
            default: 'Top up any amount.',
            'ar-SA': '',
            'de-DE': 'Lade beliebigen Betrag auf.',
            'en-US': 'Top up any amount.',
            'es-ES': 'Recarga cualquier monto.',
            'fr-FR': 'Rechargez n’importe quelle quantité.',
            'id-ID':
              'Selesaikan pengisian saldo sekali dengan jumlah berapa pun',
            'it-IT': 'Ricarica qualsiasi importo.',
            'ja-JP': '任意の金額でチャージを1回完了',
            'ko-KR': '임의 금액 1회 충전 완료',
            'pl-PL': '',
            'pt-PT': 'Recarregue qualquer quantia.',
            'ru-RU': 'Пополните счет на любую сумму.',
            'th-TH': 'เติมเงินสำเร็จ 1 ครั้ง',
            'tr-TR': 'Dilediğin miktarda yükleme yap.',
            'vi-VN': 'Hoàn thành 1 lần nạp mốc bất kỳ',
            'zh-CN': '完成一次任意金额储值',
            'zh-TW': '完成一次任意金額儲值'
          }
        },
        3: {
          limitedPay: false,
          limitedTime: '',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-3.png'),
              num: 3
            }
          ],
          awardDetail: {
            default: '500 VIP Credit*3',
            'ar-SA': '',
            'de-DE': 'VIP-Kredit x500*3',
            'en-US': '500 VIP Credit*3',
            'es-ES': 'Crédito VIP x500*3',
            'fr-FR': 'Crédit VIP x 500*3',
            'id-ID': '500 Poin VIP*3',
            'it-IT': '500 Crediti VIP*3',
            'ja-JP': 'VIPポイント500pt*3',
            'ko-KR': 'VIP 500포인트*3',
            'pl-PL': '',
            'pt-PT': 'Crédito VIP x500*3',
            'ru-RU': 'VIP Кредит x500*3',
            'th-TH': 'พอยท์ VIP 500*3',
            'tr-TR': '500 VIP Kredisi*3',
            'vi-VN': '500 điểm VIP*3',
            'zh-CN': 'VIP点数500点*3',
            'zh-TW': 'VIP點數500點*3'
          },
          taskName: {
            default: 'Monthly Log in Pack',
            'ar-SA': '',
            'de-DE': 'Monatl. Anmeldepaket',
            'en-US': 'Monthly Log in Pack',
            'es-ES': 'Paquete de inicio de sesión mensual',
            'fr-FR': 'Pack de connexion mensuel',
            'id-ID': 'Paket Login Bulanan',
            'it-IT': 'Pacchetto Accesso Mens.',
            'ja-JP': '月間ログインギフト',
            'ko-KR': '매월 로그인 패키지',
            'pl-PL': '',
            'pt-PT': 'Pacote de Login Mensal',
            'ru-RU': 'Месячный набор за вход',
            'th-TH': 'แพ็กล็อกอินรายเดือน',
            'tr-TR': 'Aylık Giriş Paketi',
            'vi-VN': 'Gói Đăng Nhập Hàng Tháng',
            'zh-CN': '每月登录礼包',
            'zh-TW': '每月登錄禮包'
          }
        },
        4: {
          limitedPay: true,
          limitedTime: 'monthly',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-4.png'),
              num: 5
            }
          ],
          awardDetail: {
            default: 'Mythic Hero Covenant*5',
            'ar-SA': '',
            'de-DE': 'Mythischer Heldenbund*5',
            'en-US': 'Mythic Hero Covenant*5',
            'es-ES': 'Convenio de Héroe mítico*5',
            'fr-FR': 'Couvent de héros mythique*5',
            'id-ID': 'Kontrak Hero Legendaris*5',
            'it-IT': `Patto Mitico dell'Eroe*5`,
            'ja-JP': 'URヒーロー契約*5',
            'ko-KR': '전설 영웅 계약*5',
            'pl-PL': '',
            'pt-PT': 'Pacto de Heróis Mítico*5',
            'ru-RU': 'Контракт Мифического Героя*5',
            'th-TH': 'สัญญาฮีโร่เลเจนด์*5',
            'tr-TR': 'Efsanevi Kahraman Kontratı*5',
            'vi-VN': 'Khế Ước Anh Hùng Truyền Kỳ*5',
            'zh-CN': '传奇英雄契约*5',
            'zh-TW': '傳奇英雄契約*5'
          },
          taskName: {
            default: 'Make top ups worth a total of ${currency} ${price}.',
            'ar-SA': '',
            'de-DE': 'Lade im Wert von insgesamt ${price} ${currency} auf.',
            'en-US': 'Make top ups worth a total of ${currency} ${price}.',
            'es-ES':
              'Realiza recargas por un valor total de ${price} ${currency}.',
            'fr-FR': 'Rechargez l’équivalent de ${price} ${currency}.',
            'id-ID': 'Akumulasi saldo sebesar ${price} ${currency}',
            'it-IT':
              'Effettua ricariche per un valore totale di ${price} ${currency}.',
            'ja-JP': '累計チャージ${price} ${currency}',
            'ko-KR': '누적 ${price} ${currency} 충전',
            'pl-PL': '',
            'pt-PT': 'Faça recargas valendo um total de ${currency} ${price}.',
            'ru-RU': 'Сделайте пополнения на общую сумму ${currency} ${price}.',
            'th-TH': 'เติมเงินสะสม ${price} ${currency}',
            'tr-TR': 'Toplam ${price} ${currency} değerinde yükleme yap.',
            'vi-VN': 'Tích lũy nạp ${price} ${currency}',
            'zh-CN': '累积储值${price} ${currency}',
            'zh-TW': '累積儲值${price} ${currency}'
          }
        },
        5: {
          limitedPay: true,
          limitedTime: 'monthly',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-5.png'),
              num: 20
            }
          ],
          awardDetail: {
            default: 'Enhancement Choice Chest*20',
            'ar-SA': '',
            'de-DE': 'Verbesserungswahltruhe*20',
            'en-US': 'Enhancement Choice Chest*20',
            'es-ES': 'Cofre de elección de Mejora*20',
            'fr-FR': 'Coffre de choix d’amélioration*20',
            'id-ID': 'Kotak Opsi Enhance*20',
            'it-IT': 'Cassa Scelta Miglioramento*20',
            'ja-JP': '強化選択ボックス*20',
            'ko-KR': '강화 선택상자*20',
            'pl-PL': '',
            'pt-PT': 'Melhore o Baú de Escolhas*20',
            'ru-RU': 'Сундук с Усилениями на Выбор*20',
            'th-TH': 'หีบเลือกตีบวก*20',
            'tr-TR': 'Geliştirme Seçim Sandığı*20',
            'vi-VN': 'Rương Cường Hóa (Chọn)*20',
            'zh-CN': '强化选择宝箱*20',
            'zh-TW': '強化選擇寶箱*20'
          },
          taskName: {
            default: 'Make top ups worth a total of ${currency} ${price}.',
            'ar-SA': '',
            'de-DE': 'Lade im Wert von insgesamt ${price} ${currency} auf.',
            'en-US': 'Make top ups worth a total of ${currency} ${price}.',
            'es-ES':
              'Realiza recargas por un valor total de ${price} ${currency}.',
            'fr-FR': 'Rechargez l’équivalent de ${price} ${currency}.',
            'id-ID': 'Akumulasi saldo sebesar ${price} ${currency}',
            'it-IT':
              'Effettua ricariche per un valore totale di ${price} ${currency}.',
            'ja-JP': '累計チャージ${price} ${currency}',
            'ko-KR': '누적 ${price} ${currency} 충전',
            'pl-PL': '',
            'pt-PT': 'Faça recargas valendo um total de ${currency} ${price}.',
            'ru-RU': 'Сделайте пополнения на общую сумму ${currency} ${price}.',
            'th-TH': 'เติมเงินสะสม ${price} ${currency}',
            'tr-TR': 'Toplam ${price} ${currency} değerinde yükleme yap.',
            'vi-VN': 'Tích lũy nạp ${price} ${currency}',
            'zh-CN': '累积储值${price} ${currency}',
            'zh-TW': '累積儲值${price} ${currency}'
          }
        },
        6: {
          limitedPay: true,
          limitedTime: 'monthly',
          award: [
            {
              icon: require('@assets/image/officialStore/dtmslg/limited-time-award-6.png'),
              num: 20
            }
          ],
          awardDetail: {
            default: 'Ascension Choice Chest*20',
            'ar-SA': '',
            'de-DE': 'Aufstiegswahltruhe*20',
            'en-US': 'Ascension Choice Chest*20',
            'es-ES': 'Cofre de elección de Ascenso*20',
            'fr-FR': 'Coffre de choix d’ascension*20',
            'id-ID': 'Kotak Opsi Ascend*20',
            'it-IT': 'Cassa Scelta Ascensione*20',
            'ja-JP': '★アップ選択ボックス*20',
            'ko-KR': '승성 선택상자*20',
            'pl-PL': '',
            'pt-PT': 'Baú de Escolha de Ascensão*20',
            'ru-RU': 'Сундук с Повышениями на Выбор*20',
            'th-TH': 'หีบเลือกอัปดาว*20',
            'tr-TR': 'Yükseltme Seçim Sandığı*20',
            'vi-VN': 'Rương Tăng Sao (Chọn)*20',
            'zh-CN': '升星选择宝箱*20',
            'zh-TW': '升星選擇寶箱*20'
          },
          taskName: {
            default: 'Make top ups worth a total of ${currency} ${price}.',
            'ar-SA': '',
            'de-DE': 'Lade im Wert von insgesamt ${price} ${currency} auf.',
            'en-US': 'Make top ups worth a total of ${currency} ${price}.',
            'es-ES':
              'Realiza recargas por un valor total de ${price} ${currency}.',
            'fr-FR': 'Rechargez l’équivalent de ${price} ${currency}.',
            'id-ID': 'Akumulasi saldo sebesar ${price} ${currency}',
            'it-IT':
              'Effettua ricariche per un valore totale di ${price} ${currency}.',
            'ja-JP': '累計チャージ${price} ${currency}',
            'ko-KR': '누적 ${price} ${currency} 충전',
            'pl-PL': '',
            'pt-PT': 'Faça recargas valendo um total de ${currency} ${price}.',
            'ru-RU': 'Сделайте пополнения на общую сумму ${currency} ${price}.',
            'th-TH': 'เติมเงินสะสม ${price} ${currency}',
            'tr-TR': 'Toplam ${price} ${currency} değerinde yükleme yap.',
            'vi-VN': 'Tích lũy nạp ${price} ${currency}',
            'zh-CN': '累积储值${price} ${currency}',
            'zh-TW': '累積儲值${price} ${currency}'
          }
        }
      }
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: true,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: (() => {
        const curDate = new Date();

        return (
          curDate > new Date('2025-10-17T00:00:00+08:00') &&
          curDate < new Date('2025-11-17T23:59:59+08:00')
        );
      })(),
      langMap: {
        'en-US': {
          show: true,
          headerTip: 'Coupon Changes Comparison',
          footerTip:
            'Note: Coupon discount caps in the Privilege Center are based on USD and may fluctuate with exchange rates. The actual discount amount will be displayed on the usage page.',
          tableHeaderTip: [
            'Premium Membership Level',
            'Original VIP Level',
            'Coupon Discount',
            'Acquisition Limit',
            'Max Discount Cap'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Once Daily', 'US$15'],
            ['Silver', 'VIP2', '7%', '15 per Month', ''],
            ['Gold', 'VIP3', '9%', '15 per Month', ''],
            ['Platinum', 'VIP4', '11%', '10 per Month', ''],
            ['Diamond', 'VIP5', '13%', '10 per Month', '']
          ],
          popupTitle: 'VIP Points System Upgraded to Privilege Center',
          popupContent:
            "Greetings, Lord!\nThank you for supporting the game! In order to provide you with a better gaming experience, the VIP Points system will be replaced with the new Privilege Center on 11/1/2025. The old VIP privileges will be integrated into the new system, and has new added benefits as well. Details are as follows:\nI. Changes Details\nBetween 10/17/2025 - 11/17/2025, all players logged in to the official purchases website will still receive the Weekly VIP Coupon, and the number the number of coupons obtained is based on the VIP Points Event.\nStarting from 11/18/2025, all players can redeem new coupons in the Privilege Center. The Privilege Center's coupons have a maximum deduction limit. Refer to the table at the bottom of the page for new coupon rules and available quantities.\nNote: Automatic coupon distribution needs to be manually activated. How to Activate: Privilege Center Homepage - View Member Privileges - Automatic Coupon Distribution - Tap/Click Activate - Select the Coupon to be Automatically Redeemed - Confirm Activation\nII. New Points Redemptions\nThe Privilege Center has a Points Redemption feature. Players can earn points by logging in to the game and completing the quests shown in the Privilege Center to redeem exclusive coupons, rare items, and other valuable rewards (see the Privilege Center interface for specific quantities available).\nCarried Over VIP Levels\nYour VIP level and accumulated points will be carried over to the Privilege Center, automatically converting to the corresponding Privilege Center Lv., with original VIP privileges retained and upgraded."
        },
        'zh-CN': {
          show: true,
          headerTip: '三方优惠券变动对比',
          footerTip:
            '请注意：【权益中心】优惠券减免上限以USD为基准，受汇率波动影响，以实际使用页面展示为准',
          tableHeaderTip: [
            '兑换门槛-权益中心等级',
            '原VIP等级',
            '优惠券折扣',
            '获取限制',
            '减免上限'
          ],
          tableBodyTip: [
            ['青铜', 'VIP1', '5%', '1次/日', '15USD'],
            ['白银', 'VIP2', '7%', '15次/月', ''],
            ['黄金', 'VIP3', '9%', '15次/月', ''],
            ['铂金', 'VIP4', '11%', '10次/月', ''],
            ['钻石', 'VIP5', '13%', '10次/月', '']
          ],
          popupTitle: '关于VIP积分机制升级为【权益中心】',
          popupContent:
            '尊敬的领主：\n感谢您一直以来的支持！为提供更优质的福利体验，我们将于2025年11月1日对原有VIP积分机制进行全面改版升级，推出全新「权益中心」系统。此次改版将整合原有VIP权益，并新增更多福利，具体调整如下：\n一、改版内容说明\n2025年10月17日-11月17日期间，所有玩家登录【官网储值页】仍可领取「每周VIP优惠券」，可获得优惠券数量与【VIP积分活动】一致。\n2025年11月18日起，所有玩家可以在【权益中心】兑换新版优惠券，权限中心优惠券将会有最高抵扣金额限制，新优惠券规则及可获取数量可参考页面下方表格\n请注意：自动发放优惠券功能需手动开启，开启路径：权益中心首页-查看会员权益-优惠券自动发放-点击开启-选择需要自动兑换的优惠券-确认开启\n二、新增积分兑换福利\n权益中心将开放「积分兑换」功能，玩家可通过参与登录游戏、完成权益中心指定任务等方式获取积分，兑换专属优惠券、稀有道具等超值奖励（具体可兑换数量详见权益中心界面）。\nVIP等级继承保障\n原VIP等级及累计积分将完整继承至权益中心，并自动转换为对应权益中心的等级身份，原有VIP特权将同步保留且优化升级。'
        },
        'zh-TW': {
          show: true,
          headerTip: '優惠券變動對比',
          footerTip:
            '請注意：【權益中心】優惠券折抵上限以美元為基準，受匯率波動影響，以實際使用頁面顯示為準',
          tableHeaderTip: [
            '兌換門檻-大會員等級',
            '原VIP等級',
            '優惠券折扣',
            '獲取限制',
            '折抵上限'
          ],
          tableBodyTip: [
            ['青銅', 'VIP1', '5%', '1次/日', '15美元'],
            ['白銀', 'VIP2', '7%', '15次/月', ''],
            ['黃金', 'VIP3', '9%', '15次/月', ''],
            ['白金', 'VIP4', '11%', '10次/月', ''],
            ['鑽石', 'VIP5', '13%', '10次/月', '']
          ],
          popupTitle: '關於VIP積分機制升級為【權益中心】',
          popupContent:
            '尊敬的領主：\n感謝您一直以來的支持！為提供更優質的福利體驗，我們將於2025年11月1日對原有VIP積分機制進行全面改版升級，推出全新「權益中心」系統。此次改版將整合原有VIP權益，並新增更多福利，具體調整如下：\n一、改版內容說明\n2025年10月17日-11月17日期間，所有玩家登入【官網儲值頁】仍可領取「每週VIP優惠券」，可獲得優惠券數量與【VIP積分活動】一致。\n2025年11月18日起，所有玩家可以在【權益中心】兌換新版優惠券，權限中心優惠券將會有最高抵扣金額限制，新優惠券規則及可獲取數量可參考頁面下方表格。\n請注意：自動發放優惠券功能需手動開啟，開啟路徑：權益中心首頁-查看會員權益-優惠券自動發放-點擊開啟-選擇需要自動兌換的優惠券-確認開啟。\n二、新增積分兌換福利\n權益中心將開放「積分兌換」功能，玩家可透過參與登入遊戲、完成權益中心指定任務等方式獲取積分，兌換專屬優惠券、稀有道具等超值獎勵（具體可兌換數量詳見權益中心介面）。\nVIP等級繼承保障\n原VIP等級及累計積分將完整繼承至權益中心，並自動轉換為對應權益中心的等級身份，原有VIP特權將同步保留且優化升級。'
        },
        'ja-JP': {
          // 日语不展示
          show: false,
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []],
          popupTitle:
            'VIPポイントシステムが「プレミアムセンター」へアップグレードしました',
          popupContent:
            'ロードさま、\n日頃よりご愛顧いただき、誠にありがとうございます。より充実した特典体験をご提供するため、2025年11月1日に現行のVIPポイントシステムを全面的にリニューアルし、新たに「プレミアムセンター」システムを導入いたします。今回のリニューアルでは、既存のVIP特典を統合し、さらに多くの特典を追加いたします。具体的な変更点は以下の通りです。\n2025年10月17日から11月17日までの期間、すべてのプレイヤーは「公式チャージページ」にて「週間VIP割引クーポン」を受け取ることができます。\n2025年11月18日より、公式VIP割引クーポンは終了いたします。以降、プレイヤーの皆様は「プレミアムセンター」でゲームアイテムギフトの交換や幸運抽選を参加することとなります。\nプレミアムセンターでは「ポイント交換」機能が開放されます。プレイヤーの皆様はゲームへのログインやプレミアムセンター指定のクエスト完了などでポイントを獲得し、レアアイテムなどの超お得な報酬と交換できます（具体的な交換可能数はプレミアムセンター画面をご確認ください）。'
        },
        'ko-KR': {
          show: true,
          headerTip: '서드 파티 쿠폰 변경 비교',
          footerTip:
            '주의: [혜택 센터] 쿠폰의 할인 한도는 USD 기준이며, 환율 변동의 영향을 받습니다. 실제 사용 페이지에 표시된 내용을 기준으로 합니다.',
          tableHeaderTip: [
            '교환 조건 - 프리미엄 레벨',
            '원래 VIP 레벨',
            '쿠폰 할인',
            '획득 제한',
            '할인 한도'
          ],
          tableBodyTip: [
            ['브론즈', 'VIP1', '5%', 'Once Daily', '15USD'],
            ['실버', 'VIP2', '7%', '15 per Month', ''],
            ['골드', 'VIP3', '9%', '15 per Month', ''],
            ['플래티넘', 'VIP4', '11%', '10 per Month', ''],
            ['다이아', 'VIP5', '13%', '10 per Month', '']
          ],
          popupTitle: 'VIP 포인트 시스템의 [혜택 센터]로의 업그레이드에 관하여',
          popupContent:
            "존경하는 영주님,\n항상 변함없는 성원에 감사드립니다! 더욱 향상된 혜택 경험을 제공하고자 2025년 11월 1일부로 기존 VIP 포인트 시스템을 전면 개편하여 새로운 「혜택 센터」 시스템을 도입할 예정입니다. 이번 개편을 통해 기존 VIP 혜택을 통합하고 더 많은 혜택을 추가할 예정이며, 구체적인 변경 사항은 다음과 같습니다:\n1. 개편 내용 설명\n2025년 10월 17일~11월 17일 기간 동안 모든 유저가 [공식 웹사이트 충전 페이지]에 접속하면 여전히 「주간 VIP 할인 쿠폰」을 받을 수 있으며, 받을 수 있는 할인 쿠폰의 수량은 [VIP 포인트 이벤트]와 동일합니다.\n2025년 11월 18일부터 모든 유저는 [혜택 센터]에서 새로운 할인 쿠폰을 교환할 수 있습니다. 혜택 센터 쿠폰에는 최대 할인 금액 제한이 적용됩니다. 새로운 쿠폰 규정 및 획득 가능 수량은 페이지 하단의 표를 참조하세요.\n주의: 쿠폰 자동 발급 기능은 수동 활성화가 필요합니다. 활성화 경로: 혜택 센터 메인 페이지 - 회원 혜택 보기 - 쿠폰 자동 발급 - 활성화 클릭 - 자동 교환할 쿠폰 선택 - 활성화 확인\n2. 포인트 교환 혜택 신규 추가\n혜택 센터에 '포인트 교환' 기능이 오픈됩니다. 유저는 게임 로그인, 혜택 센터 지정 임무 완료 등을 통해 포인트를 획득하여 전용 할인 쿠폰, 레어 아이템 등 초특가 보상으로 교환할 수 있습니다(구체적인 교환 가능 수량은 혜택 센터 화면을 참조하세요).\nVIP 레벨 승계 보장\n기존 VIP 레벨 및 누적 포인트가 혜택 센터로 완전히 승계되며, 자동으로 해당 혜택 센터의 등급으로 전환됩니다. 기존 VIP 특권은 그대로 유지되며 개선 및 업그레이드됩니다."
        },
        'vi-VN': {
          show: true,
          headerTip: 'So sánh thay đổi Coupon',
          footerTip:
            'Lưu ý: Giới hạn giảm giá phiếu ưu đãi [Trung tâm quyền lợi] dựa trên USD, chịu ảnh hưởng bởi biến động tỷ giá, vui lòng xem trang sử dụng thực tế để biết chi tiết.',
          tableHeaderTip: [
            'Ngưỡng đổi - Cấp hội viên',
            'Cấp độ VIP gốc',
            'Chiết khấu phiếu ưu đãi',
            'Giới hạn nhận',
            'Giới hạn giảm giá'
          ],
          tableBodyTip: [
            ['Đồng', 'VIP1', '5%', '1 lần/ngày', '15 USD'],
            ['Bạc', 'VIP2', '7%', '15 lần/tháng', ''],
            ['Vàng', 'VIP3', '9%', '15 lần/tháng', ''],
            ['Bạch Kim', 'VIP4', '11%', '10 lần/tháng', ''],
            ['Kim Cương', 'VIP5', '13%', '10 lần/tháng', '']
          ],
          popupTitle:
            'Về việc cơ chế điểm VIP nâng cấp thành [Trung Tâm Quyền Lợi]',
          popupContent:
            'Lãnh chúa thân mến:\nCảm ơn các Lãnh chúa đã luôn ủng hộ! Để mang đến trải nghiệm phúc lợi tốt hơn, chúng tôi sẽ tiến hành nâng cấp và cải tiến toàn diện cơ chế điểm VIP hiện có vào ngày 1 tháng 11 năm 2025, từ đó cho ra mắt hệ thống [Trung Tâm Quyền Lợi] hoàn toàn mới. Bản nâng cấp này sẽ tích hợp các quyền lợi VIP hiện có và bổ sung thêm nhiều phúc lợi mới, các điều chỉnh cụ thể như sau:\nI. Nội dung bản cập nhật\nTrong khoảng thời gian từ ngày 17/10/2025 đến 17/11/2025, tất cả người chơi khi đăng nhập [Trang nạp tiền chính thức] vẫn có thể nhận [Phiếu ưu đãi VIP hàng tuần]. Số lượng phiếu ưu đãi nhận được sẽ tương đương với [Hoạt động điểm VIP].\nKể từ ngày 18/11/2025, tất cả người chơi có thể đổi phiếu ưu đãi phiên bản mới tại [Trung tâm quyền lợi]. Phiếu ưu đãi của Trung tâm quyền lợi sẽ có hạn mức khấu trừ tối đa. Quy tắc dùng phiếu ưu đãi mới và số lượng nhận được có thể tham khảo tại bảng bên dưới trang.\nLưu ý: Tính năng phát phiếu ưu đãi tự động cần bật thủ công. Cách bật: Trang chủ Trung tâm quyền lợi - Xem quyền lợi hội viên - Tự động phát phiếu ưu đãi - Nhấn bật - Chọn phiếu ưu đãi cần tự động đổi - Xác nhận bật.\n2. Thêm mới phúc lợi đổi điểm\nTrung tâm quyền lợi sẽ mở tính năng "Đổi điểm". Người chơi có thể nhận điểm bằng cách đăng nhập vào game, hoàn thành nhiệm vụ chỉ định tại Trung tâm quyền lợi và nhiều cách khác, sau đó dùng điểm để đổi các phần thưởng siêu giá trị như phiếu ưu đãi độc quyền, đạo cụ hiếm v.v (Chi tiết số lượng đổi vui lòng xem tại giao diện Trung tâm quyền lợi).\nBảo đảm kế thừa cấp VIP\nCấp VIP cũ và điểm tích lũy sẽ được kế thừa toàn bộ sang Trung tâm quyền lợi và tự động quy đổi thành cấp bậc mới tương ứng. Các đặc quyền VIP hiện có cũng sẽ được giữ lại và tối ưu.'
        },
        'th-TH': {
          show: true,
          headerTip: 'การเปรียบเทียบการเปลี่ยนแปลงคูปอง',
          footerTip:
            'หมายเหตุ: วงเงินส่วนลดสูงสุดของตั๋วโปรโมชั่น [ศูนย์สิทธิประโยชน์] ใช้ USD เป็นเกณฑ์ ซึ่งอาจมีการเปลี่ยนแปลงตามอัตราแลกเปลี่ยน โดยอ้างอิงจากข้อมูลที่แสดงบนหน้าใช้งานจริง',
          tableHeaderTip: [
            'เกณฑ์การแลกเปลี่ยน - ระดับศูนย์สมาชิก',
            'ระดับ VIP เดิม',
            'ส่วนลดตั๋วโปรโมชั่น',
            'ขีดจำกัดการรับ',
            'ขีดจำกัดการลด'
          ],
          tableBodyTip: [
            ['บรอนซ์', 'VIP1', '5%', '1 ครั้ง/วัน', '15 USD'],
            ['ซิลเวอร์', 'VIP2', '7%', '15 ครั้ง/เดือน', ''],
            ['โกลด์', 'VIP3', '9%', '15 ครั้ง/เดือน', ''],
            ['แพลทตินั่ม', 'VIP4', '11%', '10 ครั้ง/เดือน', ''],
            ['ไดมอนด์', 'VIP5', '13%', '10 ครั้ง/เดือน', '']
          ],
          popupTitle: 'แจ้งการอัปเกรดระบบคะแนน VIP เป็น [ศูนย์สิทธิประโยชน์]',
          popupContent:
            'ท่านลอร์ดที่รัก:\nขอบคุณสำหรับการสนับสนุนอย่างต่อเนื่องเสมอมา! เพื่อมอบประสบการณ์สิทธิประโยชน์ที่ดียิ่งขึ้น เราจะทำการปรับปรุงระบบคะแนน VIP เดิมครั้งใหญ่ในวันที่ 2025/11/1 และเปิดตัวระบบใหม่ล่าสุด 「ศูนย์สิทธิประโยชน์」 การปรับปรุงครั้งนี้จะรวบรวมสิทธิประโยชน์ VIP เดิม พร้อมเพิ่มสิทธิประโยชน์ใหม่ๆ อีกมากมาย โดยมีรายละเอียดการปรับเปลี่ยนดังนี้:\n1. รายละเอียดการปรับปรุง\nในช่วงวันที่ 2025/10/17 - 2025/11/17 ผู้เล่นทุกท่านยังสามารถล็อกอิน [หน้าเติมเงินเว็บไซต์ทางการ] เพื่อรับ 「คูปอง VIP รายสัปดาห์」 ได้เช่นเดิม โดยจำนวนคูปองที่ได้รับจะเท่ากับใน [กิจกรรมคะแนน VIP]\nตั้งแต่วันที่ 2025/11/18 ผู้เล่นสามารถแลกคูปองรูปแบบใหม่ได้ที่ [ศูนย์สิทธิประโยชน์] โดยคูปองจะมีการจำกัดยอดส่วนลดสูงสุด สามารถตรวจสอบกฎและจำนวนที่รับได้จากตารางด้านล่าง\nโปรดทราบ: ฟังก์ชันส่งคูปองอัตโนมัติต้องเปิดใช้งานด้วยตนเอง เส้นทาง: หน้าหลักศูนย์สิทธิประโยชน์→ดูสิทธิประโยชน์สมาชิก→ส่งคูปองอัตโนมัติ→คลิกเปิด→เลือกคูปองที่ต้องการแลกอัตโนมัติ→ยืนยัน\n2. เพิ่มสิทธิประโยชน์การแลกคะแนนสะสม\nศูนย์สิทธิประโยชน์จะเปิดให้บริการฟังก์ชัน[แลกคะแนนสะสม] ผู้เล่นสามารถสะสมคะแนนได้จากการล็อกอินเข้าเกม, ทำภารกิจที่ศูนย์สิทธิประโยชน์กำหนด และกิจกรรมอื่นๆ เพื่อแลกรับรางวัลสุดคุ้มมากมาย อาทิ คูปองพิเศษและไอเทมหายาก (ตรวจสอบจำนวนรางวัลที่แลกได้จากหน้าศูนย์สิทธิประโยชน์)\nรับประกันการสืบทอดระดับ VIP\nระดับ VIP และคะแนนสะสมเดิมจะถูกโอนไปยังศูนย์สิทธิประโยชน์ พร้อมแปลงเป็นระดับที่สอดคล้องกันโดยอัตโนมัติ โดยสิทธิพิเศษ VIP เดิมจะยังคงอยู่และได้รับการปรับปรุงให้ดียิ่งขึ้น'
        },
        'de-DE': {
          show: true,
          headerTip: 'Coupon-Änderungsvergleich',
          footerTip:
            'Hinweis: Die Rabattgrenzen für Coupons im Privilegzentrum basieren auf USD und können aufgrund von Wechselkursschwankungen variieren. Der tatsächliche Rabattbetrag wird auf der Nutzungsseite angezeigt.',
          tableHeaderTip: [
            'Einlöseanforderungen - Premium-Mitgliedschaftslevel',
            'Ursprüngliches VIP-Level',
            'Coupon-Rabatt',
            'Erwerbslimit',
            'Max. Rabattgrenze'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Einmal täglich', '15$'],
            ['Silber', 'VIP2', '7%', '15-mal pro Monat', ''],
            ['Gold', 'VIP3', '9%', '15-mal pro Monat', ''],
            ['Platin', 'VIP4', '11%', '10-mal/Monat', ''],
            ['Diamant', 'VIP5', '13%', '10-mal/Monat', '']
          ],
          popupTitle: 'VIP-Punktesystem aufgewertet zum Privilegzentrum',
          popupContent:
            'Hallo Lord!\nVielen Dank für deine Unterstützung des Spiels! Um dir ein besseres Spielerlebnis zu bieten, wird das VIP-Punktesystem am 01.11.2025 durch das neue Privilegzentrum ersetzt. Die alten VIP-Privilegien werden in das neue System integriert und es gibt auch neue zusätzliche Vorteile. Die Details sind wie folgt:\nI. Änderungen im Detail\nZwischen dem 17.10.2025 und dem 17.11.2025 erhalten alle Spieler, die sich auf der offiziellen Kauf-Website anmelden, weiterhin den wöchentlichen VIP-Gutschein, und die Anzahl der erhaltenen Gutscheine basiert auf dem VIP-Punkte-Event.\nAb dem 18.11.2025 können alle Spieler neue Gutscheine im Privilegzentrum einlösen. Die Gutscheine im Privilegzentrum haben eine maximale Ermäßigungsgrenze. Die neuen Gutscheinregeln und verfügbaren Mengen findest du in der Tabelle am Ende der Seite.\nHinweis: Die automatische Gutscheinverteilung muss manuell aktiviert werden. Aktivierungsanleitung: Startseite des Privilegzentrums - Mitgliederprivilegien anzeigen - Automatische Gutscheinverteilung - Tippe auf Aktivieren - Wähle den automatisch einzulösenden Gutschein aus - Bestätige die Aktivierung.\nII. Neue Punkteeinlösungen\nDas Privilegzentrum verfügt über eine Punkteeinlösungsfunktion. Spieler können Punkte sammeln, indem sie sich im Spiel anmelden und die im Privilegzentrum angezeigten Quests erfüllen, um exklusive Gutscheine, seltene Items und andere wertvolle Belohnungen einzulösen (spezifische verfügbare Mengen findest du in der Benutzeroberfläche des Privilegzentrums).\nÜbertragene VIP-Level\nDein VIP-Level und deine gesammelten Punkte werden ins Privilegzentrum übertragen und automatisch in das entsprechende Privilegzentrum Lv. umgewandelt, wobei die ursprünglichen VIP-Privilegien beibehalten und aufgewertet werden.'
        },
        'fr-FR': {
          show: true,
          headerTip: 'Comparaison des modifications de coupons',
          footerTip: `Remarque : les réductions maximales des coupons dans le Centre de privilèges sont basées sur le $ et peuvent varier en fonction des taux de change. Le montant réel de la réduction sera affiché sur la page d'utilisation.`,
          tableHeaderTip: [
            `Conditions d'Échange - Niveau d'Abonnement Premium`,
            `Niveau VIP d'origine`,
            'Réduction de Coupon',
            `Limite d'Acquisition`,
            `Réduction Maximale`
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Une Fois par Jour', '15 $'],
            ['Argent', 'VIP2', '7%', '15 fois par mois', ''],
            ['Or', 'VIP3', '9%', '15 fois par mois', ''],
            ['Platine', 'VIP4', '11%', '10 fois par mois', ''],
            ['Diamant', 'VIP5', '13%', '10 fois par mois', '']
          ],
          popupTitle: 'Le système de Points VIP passe au Centre de Privilèges',
          popupContent:
            "Salutations, Seigneur !\nNous vous remercions de votre soutien ! Pour optimiser votre expérience de jeu, le système de Points VIP sera remplacé par le nouveau Centre de Privilèges le 1/11/2025. Vos anciens Privilèges VIP seront intégrés et de nouveaux avantages seront ajoutés. Détails ci-dessous :\nI. Détails des modifications\nDu 17/10/2025 au 17/11/2025, tout joueur se connectant à la boutique officielle continuera de recevoir le Coupon VIP hebdomadaire. Le nombre de coupons obtenus dépendra de l'événement Points VIP.\nDès le 18/11/2025, tous les joueurs pourront réclamer de nouveaux coupons au Centre de Privilèges. Les coupons du Centre de Privilèges sont soumis à un plafond de déduction. Consultez le tableau en bas de page pour connaître les nouvelles règles et les quantités disponibles.\nRemarque : La distribution automatique de coupons doit être activée manuellement. Comment activer : Page d'accueil du Centre de Privilèges - Voir les Privilèges de membre - Distribution automatique de Coupons - Appuyez/Cliquez sur Activer - Sélectionnez le Coupon à réclamer automatiquement - Confirmez l'activation.\nII. Nouveaux échanges de points\nLe Centre de Privilèges propose une fonctionnalité d'Échange de points. Les joueurs peuvent gagner des points en se connectant au jeu et en accomplissant les quêtes affichées dans le Centre de Privilèges pour réclamer des coupons exclusifs, des objets rares et d'autres récompenses précieuses (consultez l'interface du Centre de Privilèges pour les quantités exactes disponibles).\nNiveaux VIP reportés\nVotre niveau VIP et vos points cumulés seront transférés au Centre de Privilèges, se convertissant automatiquement en un niveau de Centre de Privilèges correspondant. Vos Privilèges VIP d'origine seront maintenus et améliorés."
        },
        'ru-RU': {
          show: true,
          headerTip: 'Сравнение изменений купонов',
          footerTip:
            'Обратите внимание: купонная скидка в Центре привилегий рассчитывается в долларах США и может меняться в зависимости от курса валют. Фактический размер скидки будет отображаться на странице использования.',
          tableHeaderTip: [
            'Требования к обмену – уровень Премиум участника',
            'Исходный VIP-уровень',
            'Купонная скидка',
            'Лимит получения',
            'Максимальная скидка'
          ],
          tableBodyTip: [
            ['Бронза', 'VIP1', '5%', 'Раз в день', '$15'],
            ['Серебро', 'VIP2', '7%', '15 раз/мес.', ''],
            ['Золото', 'VIP3', '9%', '15 раз/мес.', ''],
            ['Платина', 'VIP4', '11%', '10 раз/мес.', ''],
            ['Алмаз', 'VIP5', '13%', '10 раз/мес.', '']
          ],
          popupTitle: 'Система VIP-очков улучшена до Центра привилегий',
          popupContent:
            'Приветствуем, Лорд!\nБлагодарим за поддержку игры! Для улучшения игрового процесса система VIP-очков будет заменена новым Центром привилегий 1/11/2025. Старые VIP-привилегии будут интегрированы в новую систему и дополнены новыми бонусами. Подробности ниже:\nI. Подробности изменений\nС 17/10/2025 по 17/11/2025 все игроки, посетившие официальный сайт пополнения счета, по-прежнему будут получать еженедельные VIP-купоны, при этом количество получаемых купонов будет определяться событием VIP-очков.\nС 18/11/2025 все игроки смогут обменять новые купоны в Центре привилегий. Купоны Центра привилегий обладают максимальным лимитом скидок. Новые правила купонов и их количество смотрите в таблице внизу страницы.\nПримечание: автоматическую выдачу купонов нужно активировать вручную. Как активировать: Центр привилегий - Обзор привилегий - Автоматическая выдача купонов - Нажать "Активировать" - Выбрать купон для автообмена - Подтвердить активацию\nII. Обмен новых очков\nВ Центре привилегий доступна функция обмена очков. Игроки могут зарабатывать очки за вход в игру и выполнение заданий Центра привилегий, чтобы обменять их на эксклюзивные купоны, редкие предметы и другие ценные награды (количество доступных наград смотрите в интерфейсе Центра привилегий).\nПеренос VIP-уровней\nВаш VIP-уровень и накопленные очки будут перенесены в Центр привилегий и автоматически конвертированы в соответствующий уровень Центра привилегий. При этом исходные VIP-привилегии сохранятся и будут улучшены.'
        },
        'pt-PT': {
          show: true,
          headerTip: 'Comparação de alterações de cupom',
          footerTip:
            'Nota: Os limites de desconto de cupom no Centro de Privilégios são baseados em USD (Dólares) e podem variar com as taxas de câmbio. O valor real do desconto será exibido na página de uso.',
          tableHeaderTip: [
            'Requisitos de Resgate - Nível de Associação Premium',
            'Nível VIP original',
            'Desconto do cupom',
            'Limite de Aquisição',
            'Limite Máximo de Desconto'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', 'Uma vez por dia', '$15'],
            ['Prata', 'VIP2', '7%', '15 Vezes/Mês', ''],
            ['Ouro', 'VIP3', '9%', '15 Vezes/Mês', ''],
            ['Platina', 'VIP4', '11%', '10 Vezes/Mês', ''],
            ['Diamante', 'VIP5', '13%', '10 Vezes/Mês', '']
          ],
          popupTitle:
            'Sistema de Pontos VIP atualizado para Centro de Privilégios',
          popupContent:
            'Saudações, Lorde!\nObrigado por apoiar o jogo! Para lhe proporcionar uma melhor experiência de jogo, o sistema de Pontos VIP será substituído pelo novo Centro de Privilégios em 01/11/2025. Os antigos privilégios VIP serão integrados ao novo sistema e, também, possui novos benefícios adicionados. Os detalhes são os seguintes:\nI. Detalhes das Mudanças\nEntre 17/10/2025 e 17/11/2025, todos os jogadores que entrarem no site oficial de compras ainda receberão o Cupom VIP Semanal, e o número de cupons obtidos tem base no Evento de Pontos VIP.\nA partir de 18/11/2025, todos os jogadores podem resgatar novos cupons no Centro de Privilégios. Os cupons do Centro de Privilégios têm um limite máximo de dedução. Consulte a tabela na parte inferior da página para conhecer as novas regras de cupons e as quantidades disponíveis.\nObservação: a distribuição automática de cupons precisa ser ativada manualmente. Como Ativar: Página Inicial do Centro de Privilégios - Ver Privilégios de Membros - Distribuição Automática de Cupons - Toque/Clique em Ativar - Selecione o Cupom a ser Resgatado Automaticamente - Confirme a Ativação\nII. Novos Resgates de Pontos\nO Centro de Privilégios possui um recurso de Resgate de Pontos. Os jogadores podem ganhar pontos entrando no jogo e concluindo as missões mostradas no Centro de Privilégios para resgatar cupons exclusivos, itens raros e outras recompensas valiosas (consulte a interface do Centro de Privilégios para quantidades específicas disponíveis).\nNíveis VIP Transferidos\nO seu nível VIP e os pontos acumulados serão transferidos para o Centro de Privilégios, convertendo automaticamente para o nv. correspondente do Centro de Privilégios, com os privilégios VIP originais mantidos e atualizados.'
        },
        'es-ES': {
          show: true,
          headerTip: 'Comparación de cambios en cupones',
          footerTip:
            'Nota: Los límites de descuento de los cupones del Centro de privilegios son en USD y pueden fluctuar con los tipos de cambio. El importe real del descuento se mostrará en la página de uso.',
          tableHeaderTip: [
            'Requisitos de canje - Nivel de membresía prémium',
            'Nivel VIP original',
            'Descuento del cupón',
            'Límite de adquisición',
            'Límite máximo de descuento'
          ],
          tableBodyTip: [
            ['Bronce', 'VIP1', '5%', 'Una vez al día', '15 $'],
            ['Plata', 'VIP2', '7%', '15 veces/mes', ''],
            ['Oro', 'VIP3', '9%', '15 veces/mes', ''],
            ['Platino', 'VIP4', '11%', '10 veces/mes', ''],
            ['Diamante', 'VIP5', '13%', '10 veces/mes', '']
          ],
          popupTitle:
            'Sistema de Puntos VIP reemplazado por el Centro de Privilegios',
          popupContent:
            '¡Saludos, milord!\n¡Gracias por seguir apoyando el juego! Con el fin de ofrecerte una mejor experiencia, el sistema de Puntos VIP será reemplazado por el nuevo Centro de Privilegios el 1/11/2025. Los antiguos beneficios VIP se integrarán en este nuevo sistema, que además incluirá ventajas adicionales. Más detalles a continuación:\nI. Detalles de los cambios\nDel 17/10/2025 al 17/11/2025, todos los jugadores que inicien sesión en el sitio oficial de compras seguirán recibiendo el Cupón VIP Semanal. La cantidad de cupones obtenidos se determinará según los resultados del evento de Puntos VIP.\nA partir del 18/11/2025, todos los jugadores podrán canjear nuevos cupones en el Centro de Privilegios. Los cupones del Centro de Privilegios cuentan con un límite máximo de descuento. Consulta la tabla al final de la página para conocer las nuevas reglas de los cupones y las cantidades disponibles.\nNota: La distribución automática de cupones debe activarse manualmente. Cómo activarla:\nCentro de Privilegios - Ver privilegios de miembro - Distribución automática de cupones - Tocar/Hacer clic en Activar - Seleccionar el cupón a canjear automáticamente - Confirmar activación.\nII. Nuevo sistema de canje de puntos\nEl Centro de Privilegios incorpora una función de Canje de Puntos. Los jugadores pueden obtener puntos iniciando sesión en el juego y completando las misiones que aparecen en el Centro de Privilegios. Estos puntos se pueden canjear por cupones exclusivos, objetos raros y otras recompensas valiosas. (Consulta la interfaz del Centro de Privilegios para ver las cantidades disponibles).\nTransferencia de Niveles VIP\nTu nivel VIP y los puntos acumulados se transferirán automáticamente al Centro de Privilegios, convirtiéndose en el nivel equivalente dentro del nuevo sistema. Tus privilegios VIP originales se conservarán y recibirán mejoras adicionales en el Centro de Privilegios.'
        },
        'it-IT': {
          show: true,
          headerTip: 'Confronto delle modifiche ai coupon',
          footerTip: `Nota: I massimali di sconto dei buoni nel Centro Privilegi si basano su USD e possono variare in base ai tassi di cambio. L'importo effettivo dello sconto viene visualizzato nella pagina di utilizzo.`,
          tableHeaderTip: [
            'Requisiti per il Riscatto - Membro Livello Premium',
            'Livello VIP originale',
            'Sconto Buono',
            'Limite di Acquisizione',
            'Limite Sconto Massimo'
          ],
          tableBodyTip: [
            ['Bronzo', 'VIP1', '5%', 'Una Volta al Giorno', '$15'],
            ['Argento', 'VIP2', '7%', '15 Volte/Mese', ''],
            ['Oro', 'VIP3', '9%', '15 Volte/Mese', ''],
            ['Platino', 'VIP4', '11%', '10 Volte/Mese', ''],
            ['Diamante', 'VIP5', '13%', '10 Volte/Mese', '']
          ],
          popupTitle:
            'Aggiornamento del Sistema Punti VIP: Ecco il Centro Privilegi',
          popupContent:
            "Saluti, Signore!\nGrazie per il tuo sostegno! Per garantirti un'esperienza di gioco ancora migliore, a partire dall'11/1/2025 il sistema Punti VIP verrà sostituito dal nuovo Centro Privilegi. I privilegi VIP precedenti saranno integrati nel nuovo sistema, con l'aggiunta di nuovi vantaggi. Di seguito i dettagli:\nI. Dettagli delle Modifiche\nDal 17/10/2025 al 17/11/2025, tutti i giocatori che accederanno al sito ufficiale degli acquisti continueranno a ricevere il Buono VIP settimanale; il numero di buoni ottenuti dipenderà dall'Evento Punti VIP.\nA partire dal 18/11/2025, tutti i giocatori potranno riscattare nuovi buoni nel Centro Privilegi. I buoni prevedono un limite di sconto massimo. Per il nuovo regolamento e le quantità disponibili, consulta la tabella a fondo pagina.\nNota: la distribuzione automatica dei buoni va attivata manualmente. Come attivare: Homepage Centro Privilegi - Visualizza Privilegi Membro - Distribuzione Automatica Buoni - Tocca Attiva - Seleziona buono da riscattare in automatico - Conferma Attivazione\nII. Nuovi Riscatti Punti\nIl Centro Privilegi dispone della funzione Riscatto Punti. I giocatori guadagnano punti accedendo al gioco e completando le missioni indicate nel Centro Privilegi, per poi riscattare buoni esclusivi, oggetti rari e altre preziose ricompense (le quantità disponibili sono visibili nell'interfaccia del Centro Privilegi).\nMantenimento Livelli VIP\nIl tuo livello VIP e i punti accumulati verranno trasferiti al Centro Privilegi e convertiti automaticamente nel Liv. corrispondente. I privilegi VIP originali saranno mantenuti e potenziati."
        },
        'id-ID': {
          show: true,
          headerTip: 'Perbandingan Perubahan Kupon',
          footerTip:
            'Perhatian: Limit maksimal diskon kupon di [Pusat Benefit] berdasarkan USD. Karena fluktuasi nilai tukar, jumlah yang ditampilkan di halaman penggunaan aktual adalah yang berlaku.',
          tableHeaderTip: [
            'Syarat Penukaran - Level Anggota VIP',
            'Level VIP Asli',
            'Diskon Kupon',
            'Limit perolehan',
            'Limit diskon'
          ],
          tableBodyTip: [
            ['Bronze', 'VIP1', '5%', '1x/hari', '15USD'],
            ['Silver', 'VIP2', '7%', '15x/bulan', ''],
            ['Gold', 'VIP3', '9%', '15x/bulan', ''],
            ['Platinum', 'VIP4', '11%', '10x/bulan', ''],
            ['Diamond', 'VIP5', '13%', '10x/bulan', '']
          ],
          popupTitle:
            'Tentang perubahan mekanisme Poin VIP menjadi [Pusat Benefit]',
          popupContent:
            'Lord Terhormat:\nTerima kasih atas dukunganmu selama ini! Untuk memberikan pengalaman benefit yang lebih baik, kami akan melakukan pembaruan menyeluruh pada mekanisme Poin VIP yang ada pada 1/11/2025, dan meluncurkan sistem baru "Pusat Benefit". Pembaruan ini akan mengintegrasikan benefit VIP yang ada dan menambahkan lebih banyak keuntungan. Berikut rincian perubahannya:\nI. Penjelasan Isi Pembaruan\nSelama periode 17/10/2025-17/11/2025, semua pemain yang login ke [halaman top up resmi] masih bisa mengambil "Kupon Diskon VIP Mingguan", jumlah kupon yang didapat sama dengan [Event Poin VIP].\nMulai 18/11/2025, semua pemain dapat menukarkan kupon baru di [Pusat Benefit]. Kupon di Pusat Benefit akan memiliki batas maksimum potongan harga. Aturan kupon baru dan jumlah yang bisa didapatkan dapat dilihat di tabel di bawah halaman.\nPerhatian: Fitur pemberian kupon otomatis perlu diaktifkan secara manual. Cara mengaktifkan: Halaman utama Pusat Benefit - Cek benefit member - Pemberian kupon otomatis - Klik aktifkan - Pilih kupon yang ingin ditukar otomatis - Konfirmasi aktivasi\nII. Penambahan Benefit Penukaran Poin\nPenukaran Poin aoam dibuka di Pusat Benefit. Pemain bisa mendapatkan poin dengan login game, menyelesaikan misi tertentu di Pusat Benefit, dll. Poin bisa ditukar dengan kupon eksklusif, Item langka, dan Hadiah bernilai tinggi lainnya (jumlah yang bisa ditukar bisa dilihat di antarmuka Pusat Benefit).\nJaminan pewarisan level VIP\nLevel VIP asli dan total poin akan diwariskan sepenuhnya ke Pusat Benefit, dan secara otomatis dikonversi menjadi Level yang sesuai di Pusat Benefit. Hak istimewa VIP yang ada akan dipertahankan dan ditingkatkan.'
        },
        'tr-TR': {
          show: true,
          headerTip: 'Kupon Değişiklikleri Karşılaştırması',
          footerTip:
            'Not: Ayrıcalık Merkezi’ndeki kupon indirim limitleri ABD doları bazındadır ve döviz kurlarına bağlı olarak değişebilir. Gerçek indirim tutarı kullanım sayfasında görüntülenecektir.',
          tableHeaderTip: [
            'Kullanım Koşulları - Ayrıcalıklı Üyelik Seviyesi',
            'Orijinal VIP Seviyesi',
            'Kupon İndirimi',
            'Satın Alma Limiti',
            'Maksimum İndirim Sınırı'
          ],
          tableBodyTip: [
            ['Bronz', 'VIP1', '5%', 'Günde bir kez', '$15'],
            ['Gümüş', 'VIP2', '7%', '15 Kez/Ayda', ''],
            ['Altın', 'VIP3', '9%', '15 Kez/Ayda', ''],
            ['Platin', 'VIP4', '11%', '10 Kez/Ayda', ''],
            ['Elmas', 'VIP5', '13%', '10 Kez/Ayda', '']
          ],
          popupTitle: 'VIP Puanı Sistemi, Ayrıcalık Merkezi Olarak Güncellendi',
          popupContent:
            "Selamlar, Lordum!\nOyunumuza gösterdiğin destek için müteşekkiriz! Size daha iyi bir oyun deneyimi sunabilmek için, 1 Kasım 2025 tarihi itibarıyla VIP Puan sistemi yerini yeni Ayrıcalık Merkezi'ne bırakacak. Eski VIP ayrıcalıkları yeni sisteme entegre edilecek ve yeni faydalar da eklenecek. Ayrıntılar şöyle:\nI. Değişiklik Detayları\n17 Ekim 2025 - 17 Kasım 2025 tarihleri arasında, resmi satın alma sitesine giriş yapan tüm oyuncular Haftalık VIP Kuponlarını alacak ve kupon sayısı VIP Puanı Etkinliği'ne göre belirlenecek.\n18 Kasım 2025 tarihinden itibaren tüm oyuncular Ayrıcalık Merkezi'nde yeni kuponları kullanabilecek. Ayrıcalık Merkezi'ndeki kuponlar için maksimum indirim limiti bulunuyor. Yeni kupon kuralları ve mevcut miktarlar için sayfanın altındaki tabloya göz atın.\nNot: Otomatik kupon dağıtımının manuel olarak etkinleştirilmesi gerekir. Nasıl Etkinleştirilir: Ayrıcalık Merkezi Ana Sayfası - Üye Ayrıcalıklarını Görüntüle - Otomatik Kupon Dağıtımı - Etkinleştir'e Dokun/Tıkla - Otomatik Kullanılacak Kuponu Seç - Etkinleştirmeyi Onayla\nII. Yeni Puan Kullanımları\nAyrıcalık Merkezi'nde Puan Kullanma özelliği bulunmaktadır. Oyuncular, oyuna giriş yaparak ve Ayrıcalık Merkezi'nde gösterilen görevleri tamamlayarak puan kazanabilir ve bu puanları kullanarak özel kuponlar, nadir öğeler ve diğer değerli ödüller alabilirler (mevcut miktarlar için Ayrıcalık Merkezi arayüzüne göz atın).\nAktarılan VIP Seviyeleri\nVIP seviyeniz ve birikmiş puanlarınız Ayrıcalık Merkezi'ne aktarılarak otomatik olarak karşılık gelen Ayrıcalık Merkezi Seviyesine dönüştürülecek, orijinal VIP ayrıcalıkları korunacak ve yükseltilecek."
        }
      }
    }
  },
  // 日本江山美人
  2: {
    platform: 'jp',
    gameCode: 'beauty',
    pageTitle: 'Recharge Center',
    pageIco: require('@assets/image/officialStore/beauty/beauty.png'),
    isUidLogin: true,
    isAccountLogin: false,
    isUidTokenLogin: true,
    uidGuidePopupGameImg1: require('@assets/image/officialStore/beauty/uid-guide-img-1.jpeg'),
    uidGuidePopupGameImg2: require('@assets/image/officialStore/beauty/uid-guide-img-2.jpeg'),
    uidTokenGuidePopupGameImg: '',
    isVipScore: true,
    isHeaderCoupon: true,
    isCustomProductType: false,
    // 是否使用新版导航栏入口和代金币功能呢
    isUpdateNewVersion: true,
    // 是否显示钱包入口
    isShowWallet: true,
    // 是否使用新版储值福利和代金币功能(黑五版本)
    isBlackFridayVersion: false,
    isShowAdvertiseBar: false,
    isShowShareBtn: false,
    coinsName: '交換コイン',
    isReadCpProductExt: true,
    isReadProductIco: true,
    productPropDefaultIcoName: 'daibi.png',
    loginType: 'account',
    isCartDoubleQuanTip: false,
    // 代币多语言说明，每个游戏的说明不一样
    coinsIntro: {
      'ar-SA': '',
      'de-DE': '',
      'en-US': '',
      'es-ES': '',
      'fr-FR': '',
      'id-ID': '',
      'it-IT': '',
      'ja-JP':
        '『日替わり内室』運営チームが新たに交換コイン機能を新設しました。ご利用中のアカウントに関連情報を提供する可能性があります。交換コインとは、商品やサービスを購入するために使用するプリペイド機能です。銀行が発行する通貨やその他の支払い手段とは異なります。クレジットカード、プリペイドカード、または『日替わり内室』運営チームが承認するその他決済方法で交換コインを購入することができます。（1回あたりの最大購入金額は運営チームによって決められます）。24時間当たりの使用金額上限（購入金額＋支出金額）は5000ドルまでとなります。ドル以外の通貨を使用する場合は、5000ドル相当の現地通貨金額となります。',
      'ko-KR': '',
      'pl-PL': '',
      'pt-PT': '',
      'ru-RU': '',
      'th-TH': '',
      'tr-TR': '',
      'vi-VN': '',
      'zh-CN': '',
      'zh-TW': ''
    },
    vipRuleConfig: {
      gameName: '日替わり内室', //游戏名，用在规则里替换
      ruleNum: 11, // 规则数量
      table: [
        ['12000', '6%OFF${couponCoupon}*1', '5%OFF${couponCoupon}*10'],
        [
          '120000',
          '7%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n6%OFF${couponCoupon}*5'
        ],
        [
          '600000',
          '9%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n7%OFF${couponCoupon}*3'
        ],
        [
          '1200000',
          '10%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n9%OFF${couponCoupon}*2'
        ],
        [
          '2400000',
          '12%OFF${couponCoupon}*1',
          '${lastAllCoupon}\n10%OFF${couponCoupon}*1'
        ]
      ],
      link: '',
      // 各币种优惠金额上限链接
      couponTopLimitLink: ''
    },
    linkEntry: {
      // 跳转banner
      link: '', // 跳转地址
      leftLink: `https://jpstore.${globalConfig.getMainHost()}/mobile/signin?gameId=2#/vip_score`, // 左边跳转地址
      rightLink: `https://auto-page.${globalConfig.getMainHost()}/jmsf210/`, // 右边跳转地址
      img: {
        // 显示的图片
        default: require('@assets/image/officialStore/beauty/left-link-banner.png'),
        'ja-JP': require('@assets/image/officialStore/beauty/left-link-banner.png')
      },
      leftImg: {
        // 左边显示的图片
        default: require('@assets/image/officialStore/beauty/left-link-banner.png'),
        'ja-JP': require('@assets/image/officialStore/beauty/left-link-banner.png')
      },
      rightImg: {
        // 右边显示的图片
        default: require('@assets/image/officialStore/beauty/right-link-banner.png'),
        'ja-JP': require('@assets/image/officialStore/beauty/right-link-banner.png')
      }
    },
    // 是否使用linkEntry轮播图,如果使用，需要配置轮播图数据
    linkEntrySwiper: [],
    // 首页是否使用轮播图，如果使用，需要配置轮播图数据
    topBannerSwiper: [],
    // 使用分享功能
    useShare: false,
    // FB分享的APPID
    shareFacebookAppId: '',
    // 分享打点上报的标识
    sharePointAid: '',
    // 添加到桌面快捷方式领奖
    pwaAward: {
      open: false,
      activityName: ''
    },
    // 支付成功邮箱引导文案
    storeSuccessEmailTips: {},
    // 是否上线权益中心
    isOnlineRightsCenter: false,
    // 暂时展示VIP规则:配置时间2025-11-18T00:00:00+08:00，在时间之前都展示，空字符则不展示
    tempShowVipRuleByRightsOnEndDate: '',
    // 权益中心链接
    rightsCenterLink: '',
    // 展示顶部安全检测
    isShowSafe: false,
    // 限时活动
    limitedTimeActivity: {
      isOpen: false,
      activitySign: ''
    },
    // 登录后才展示客服按钮
    serviceShowByLogin: false,
    // VIP积分下架说明
    vipScoreDownIntro: {
      isShow: false,
      langMap: {
        'en-US': {
          headerTip: '',
          footerTip: '',
          tableHeaderTip: [],
          tableBodyTip: [[], [], [], [], [], []]
        }
      }
    }
  }
};

export const ZTMSLG_GAMES = [191, 225, 227, 284];
export const DTMSLG_GAMES = [285, 354, 355];

// 全球平台
const globalGameId = [
  ...ZTMSLG_GAMES,
  ...DTMSLG_GAMES,
  263,
  209,
  211,
  213,
  215
];
// 日本平台
const jpGameId = [2];

// 页面有效的gameId, 无效则跳404页面
export const VALID_GAME_ID = (() => {
  if (process.env.NODE_ENV === 'production') {
    return window.location.host.includes(window.atob('anBzdG9yZS4zN2dhbWVzLmNvbQ=='))
      ? jpGameId
      : globalGameId;
  } else {
    return [...globalGameId, ...jpGameId];
  }
})();

export default gameInfoConfig;
